/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/location';
import '../common/currency';
import '../common/countries';
import './model';
import '../banklin/transaction';
import '../common/time';
import '../banklin/digital_wallet';
import './card_invitation';
import '../banklin/issued_card';
import '../banklin/octopus';
import '../common/instrument';
import '../solidshop/addressVerification/service';
import './unified_activity';
import './transaction_dispute';
import './card_management';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "service": {
            "nested": {
              "AddMobileNumberForSmsNotificationsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "mobileNumber": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "AddMobileNumberForSmsNotificationsResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "localizedErrorTitle": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "localizedErrorDescription": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CheckIdentityVerificationStatusRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pollToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CheckIdentityVerificationStatusResponse": {
                "fields": {
                  "pending": {
                    "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Pending",
                    "id": 1
                  },
                  "response": {
                    "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Response",
                    "id": 2
                  },
                  "error": {
                    "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Error",
                    "id": 3
                  }
                },
                "nested": {
                  "Response": {
                    "fields": {
                      "idvState": {
                        "type": ".squareup.bizbank.service.IdvState",
                        "id": 1,
                        "rule": "optional"
                      },
                      "idvNeedsSsn": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "canRetryIdv": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "idvError": {
                        "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.IdvError",
                        "id": 4,
                        "rule": "optional"
                      },
                      "idvRetriesRemaining": {
                        "type": "int32",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "Pending": {
                    "fields": {
                      "pollToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "IdvError": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "TOO_MANY_ATTEMPTS": 3,
                      "UNDER_AGE_OF_MAJORITY": 4,
                      "DOES_NOT_MATCH": 5
                    }
                  },
                  "Error": {
                    "fields": {
                      "reason": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "result": {
                    "oneof": [
                      "pending",
                      "response",
                      "error"
                    ]
                  }
                }
              },
              "ConfirmIssueCardRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardIssueToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 3,
                    "rule": "optional"
                  },
                  "customizationToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "shouldPauseDeposits": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "ConfirmIssueCardResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "canImmediatelyAddToWallet": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardData": {
                    "type": ".squareup.bizbank.service.CardData",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "IssueCardRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardholderPersonToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "createPhysicalCard": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createVirtualCard": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "physicalCardDetails": {
                    "type": ".squareup.bizbank.service.IssueCardRequest.PhysicalCardDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PhysicalCardDetails": {
                    "fields": {
                      "firstName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lastName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "shippingAddress": {
                        "type": ".squareup.common.location.GlobalAddress",
                        "id": 3,
                        "rule": "optional"
                      },
                      "customizationToken": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "IssueCardResponse": {
                "fields": {
                  "physicalCardData": {
                    "type": ".squareup.bizbank.service.CardData",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CreateCardCustomizationRequest": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "imageBytes": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "mimeType": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "existingTrunkToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CreateCardCustomizationResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cutomizationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "DeactivateCardRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deactivationReason": {
                    "type": ".squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DeactivationReason": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "LOST": 1,
                      "STOLEN": 2,
                      "CARD_NOT_RECEIVED": 3,
                      "CANCEL": 4,
                      "FRAUD": 5,
                      "TRANSFER_OF_ACCOUNT": 6,
                      "RISK_ACCOUNT_DEACTIVATION": 7,
                      "LOST_OR_STOLEN": 8,
                      "DAMAGED": 9
                    }
                  }
                }
              },
              "DeactivateCardResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "bizbankEnabled": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateDeactivationReasonRequest": {
                "fields": {
                  "cardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": ".squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateDeactivationReasonResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.bizbank.service.UpdateDeactivationReasonResponse.UpdateDeactivationReasonError",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "UpdateDeactivationReasonError": {
                    "values": {
                      "UPDATE_DEACTIVATION_REASON_ERROR_DO_NOT_USE": 0,
                      "UPDATE_DEACTIVATION_REASON_ERROR_INVALID_CARD_TOKEN": 1
                    }
                  }
                }
              },
              "FinishCardActivationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "activationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cvv": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "expirationMmyy": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "fideliusToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "FinishCardActivationResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.bizbank.service.FinishCardActivationResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pinIsSet": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "SUCCESS": 1,
                      "FAILED": 2,
                      "ACTIVATION_TOKEN_INVALID": 3,
                      "ACTIVATION_TOKEN_EXPIRED": 4,
                      "INCORRECT_CVV": 5,
                      "INCORRECT_EXPIRATION": 6,
                      "INCORRECT_CARD_INFO": 7
                    }
                  }
                }
              },
              "EnqueueSweepRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "EnqueueSweepResponse": {
                "fields": {}
              },
              "GetBalanceRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBalanceResponse": {
                "fields": {
                  "balance": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "maxInstantDepositAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pendingBalance": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetBizbankAccountRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeIdvData": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "GetBizbankAccountResponse": {
                "fields": {
                  "bizbankAccount": {
                    "type": ".squareup.bizbank.service.GetBizbankAccountResponse.BizbankAccount",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BizbankAccount": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isBizbankEnabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "balance": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxInstantDepositAmount": {
                        "type": ".squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "cards": {
                        "type": ".squareup.bizbank.service.CardData",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "cardActivity": {
                        "type": ".squareup.bizbank.service.CardActivity",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "pendingBalance": {
                        "type": ".squareup.common.Money",
                        "id": 7,
                        "rule": "optional"
                      },
                      "idvState": {
                        "type": ".squareup.bizbank.service.IdvState",
                        "id": 8,
                        "rule": "optional"
                      },
                      "idvAttemptsRemaining": {
                        "type": "int32",
                        "id": 9,
                        "rule": "optional"
                      },
                      "canToggleEnabled": {
                        "type": "bool",
                        "id": 10,
                        "rule": "optional"
                      },
                      "canOrderCard": {
                        "type": "bool",
                        "id": 11,
                        "rule": "optional"
                      },
                      "eligibilityReason": {
                        "type": ".squareup.bizbank.service.UnitIneligibilityReason",
                        "id": 12,
                        "rule": "optional"
                      },
                      "storedValueToken": {
                        "type": "string",
                        "id": 13,
                        "rule": "optional"
                      },
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 14,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "UnitIneligibilityReason": {
                "values": {
                  "UNKNOWN": 0,
                  "SUSPENDED_BY_MARQETA": 1,
                  "DEACTIVATED_BY_MARQETA": 2,
                  "TOO_MANY_CLAIMS": 3,
                  "NOT_ACTIVATED": 4,
                  "NOT_FOUND": 5,
                  "MCC_INELIGIBLE": 6,
                  "DEACTIVATED_BY_RISK": 7,
                  "INVALID_BUSINESS_NAME": 8,
                  "EXHAUSTED_IDV_RETRIES": 9,
                  "SUSPECTED_ATO": 10,
                  "FAKE_ACCOUNT": 11,
                  "SELLS_CANNABIS": 13,
                  "PRODUCT_LEVEL_HARDBLOCKED_BY_COMPLIANCE": 14,
                  "DECLINED_BY_RISK": 15
                }
              },
              "GetCardOrderingEligibilityRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "skipRiskproxyEvaluation": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              },
              "GetCardOrderingEligibilityResponse": {
                "fields": {
                  "canOrderCard": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idvState": {
                    "type": ".squareup.bizbank.service.IdvState",
                    "id": 3,
                    "rule": "optional"
                  },
                  "idvAttemptsRemaining": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "ineligibilityReasons": {
                    "type": ".squareup.bizbank.service.UnitIneligibilityReason",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "GetCardActivityRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "batchRequest": {
                    "type": ".squareup.bizbank.model.BatchRequest",
                    "id": 2,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": ".squareup.bizbank.service.GetCardActivityRequest.Filters",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Filters": {
                    "fields": {
                      "includeStates": {
                        "type": ".squareup.banklin.TransactionState",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "excludeStates": {
                        "type": ".squareup.banklin.TransactionState",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "minOccurredAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxOccurredAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 4,
                        "rule": "optional"
                      },
                      "excludeActivityTypes": {
                        "type": ".squareup.bizbank.service.CardActivity.ActivityType",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "includeActivityTypes": {
                        "type": ".squareup.bizbank.service.CardActivity.ActivityType",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "dateSource": {
                        "type": ".squareup.bizbank.service.GetCardActivityRequest.Filters.DateSource",
                        "id": 7,
                        "rule": "optional",
                        "options": {
                          "default": "OCCURRED_AT"
                        }
                      }
                    },
                    "nested": {
                      "DateSource": {
                        "values": {
                          "OCCURRED_AT": 1,
                          "UPDATED_AT": 2
                        }
                      }
                    }
                  }
                }
              },
              "GetCardActivityResponse": {
                "fields": {
                  "transactionEvents": {
                    "type": ".squareup.banklin.TransactionEvent",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cardActivity": {
                    "type": ".squareup.bizbank.service.CardActivity",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "batchResponse": {
                    "type": ".squareup.bizbank.service.GetCardActivityResponse.BatchResponse",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fetchedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "balance": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "maxInstantDepositAmount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BatchResponse": {
                    "fields": {
                      "nextPaginationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetCardCustomizationRequest": {
                "fields": {
                  "returnFullImage": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 1
                  },
                  "customizationToken": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "token": {
                    "oneof": [
                      "unitToken",
                      "customizationToken"
                    ]
                  }
                }
              },
              "CardCustomization": {
                "fields": {
                  "imageBytes": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "mimeType": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetCardCustomizationResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardCustomization": {
                    "type": ".squareup.bizbank.service.CardCustomization",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetEnabledRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetEnabledResponse": {
                "fields": {
                  "isEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "enabledAttributes": {
                    "type": ".squareup.bizbank.service.GetEnabledResponse.EnabledAttribute",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "EnabledAttribute": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isEnabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetEnabledHistoryRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetEnabledHistoryResponse": {
                "fields": {
                  "enabledIntervals": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "enabledIntervalsByBanklinToken": {
                    "type": ".squareup.bizbank.service.GetEnabledHistoryResponse.DateTimeIntervals",
                    "id": 2,
                    "keyType": "string"
                  }
                },
                "nested": {
                  "DateTimeIntervals": {
                    "fields": {
                      "intervals": {
                        "type": ".squareup.common.time.DateTimeInterval",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "GetCardBillingAddressRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetCardBillingAddressResponse": {
                "fields": {
                  "billingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DigitalWalletToken": {
                "fields": {
                  "digitalWalletToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "issuerCardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "digitalWalletIssuer": {
                    "type": ".squareup.banklin.DigitalWalletIssuer",
                    "id": 3,
                    "rule": "optional"
                  },
                  "digitalWalletState": {
                    "type": ".squareup.banklin.DigitalWalletState",
                    "id": 4,
                    "rule": "optional"
                  },
                  "devicePhoneNumberLastFour": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "deviceType": {
                    "type": ".squareup.banklin.DeviceType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "bizbankCardToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "panReferenceId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "GetDigitalWalletTokenRequest": {
                "fields": {
                  "digitalWalletToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetDigitalWalletTokenResponse": {
                "fields": {
                  "digitalWalletToken": {
                    "type": ".squareup.bizbank.service.DigitalWalletToken",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetDigitalWalletTokensForUnitRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetDigitalWalletTokensForUnitResponse": {
                "fields": {
                  "digitalWalletTokens": {
                    "type": ".squareup.bizbank.service.DigitalWalletToken",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetRolledUpActivityRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "batchRequest": {
                    "type": ".squareup.bizbank.model.BatchRequest",
                    "id": 2,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.Filters",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.SortOrder",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "DESC"
                    }
                  }
                },
                "nested": {
                  "SortOrder": {
                    "values": {
                      "ASC": 1,
                      "DESC": 2
                    }
                  },
                  "RolledUpActivityType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CARD_PAYMENT": 1,
                      "DEPOSIT": 2,
                      "INSTANT_DEPOSIT": 3,
                      "ATM_WITHDRAWAL": 4
                    }
                  },
                  "Filters": {
                    "fields": {
                      "includeTypes": {
                        "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.RolledUpActivityType",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "excludeTypes": {
                        "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.RolledUpActivityType",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "minOccurredAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxOccurredAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 4,
                        "rule": "optional"
                      },
                      "transactionToken": {
                        "type": "string",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "includeStates": {
                        "type": ".squareup.banklin.TransactionState",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "excludeStates": {
                        "type": ".squareup.banklin.TransactionState",
                        "id": 7,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "GetRolledUpActivityResponse": {
                "fields": {
                  "cardActivity": {
                    "type": ".squareup.bizbank.service.GetRolledUpActivityResponse.RolledUpCardActivity",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Fee": {
                    "fields": {
                      "amount": {
                        "type": ".squareup.common.Money",
                        "id": 100,
                        "rule": "optional"
                      },
                      "feeType": {
                        "type": ".squareup.bizbank.service.GetRolledUpActivityResponse.Fee.FeeType",
                        "id": 101,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "FeeType": {
                        "values": {
                          "ATM": 1,
                          "INSTANT_DEPOSIT": 2
                        }
                      }
                    }
                  },
                  "RolledUpCardActivity": {
                    "fields": {
                      "activity": {
                        "type": ".squareup.bizbank.service.CardActivity",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fee": {
                        "type": ".squareup.bizbank.service.GetRolledUpActivityResponse.Fee",
                        "id": 2,
                        "rule": "optional"
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetSpendingLimitsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetSpendingLimitsResponse": {
                "fields": {
                  "spendSummaries": {
                    "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "SpendSummary": {
                    "fields": {
                      "spendType": {
                        "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "spendLimits": {
                        "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "includesPurchases": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "includesWithdrawals": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "includesTransfers": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      },
                      "includesCashback": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional"
                      },
                      "includesCredits": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional"
                      },
                      "includesP2p": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      },
                      "controlName": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "SpendType": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "MAX_SPEND": 1,
                          "CASH_ACCESS": 2,
                          "MAX_ATM": 3,
                          "MCC_CASH_DISBURSE": 4,
                          "CASHBACK": 5,
                          "CASHBACK_RESTRICTION": 6,
                          "CASHAPP_SEND": 7,
                          "P2P_CASHAPP": 8
                        }
                      },
                      "SpendLimit": {
                        "fields": {
                          "cadence": {
                            "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.Cadence",
                            "id": 1,
                            "rule": "optional"
                          },
                          "amountAvailableToSpend": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "limitAmount": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "daysLeftInCycle": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "cardType": {
                            "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.CardType",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Cadence": {
                            "values": {
                              "DAILY": 1,
                              "WEEKLY": 2,
                              "MONTHLY": 3,
                              "SINGLE_TRANSACTION": 4
                            }
                          },
                          "CardType": {
                            "values": {
                              "PHYSICAL_CARD": 0,
                              "VIRTUAL_CARD": 1,
                              "PHYSICAL_AND_VIRTUAL_CARD": 2
                            }
                          }
                        }
                      }
                    }
                  }
                }
              },
              "GetAtmLimitsRequest": {
                "fields": {
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetAtmLimitsResponse": {
                "fields": {
                  "limits": {
                    "type": ".squareup.bizbank.service.GetAtmLimitsResponse.Limit",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Limit": {
                    "fields": {
                      "cadence": {
                        "type": ".squareup.bizbank.service.GetAtmLimitsResponse.Limit.Cadence",
                        "id": 1,
                        "rule": "optional"
                      },
                      "availableToSpendAmount": {
                        "type": ".squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "limitAmount": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Cadence": {
                        "values": {
                          "DAILY": 1,
                          "WEEKLY": 2,
                          "MONTHLY": 3,
                          "PER_TRANSACTION": 4
                        }
                      }
                    }
                  }
                }
              },
              "CreateCardInvitationRequest": {
                "fields": {
                  "firstName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "balanceId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CreateCardInvitationResponse": {
                "fields": {
                  "cardInvitation": {
                    "type": ".squareup.bizbank.invitations.CardInvitation",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SendNotificationRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardInvitationEmail": {
                    "type": ".squareup.bizbank.service.SendNotificationRequest.CardInvitationEmailPayload",
                    "id": 2
                  }
                },
                "nested": {
                  "CardInvitationEmailPayload": {
                    "fields": {
                      "cardInvitationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "notification_payload": {
                    "oneof": [
                      "cardInvitationEmail"
                    ]
                  }
                }
              },
              "SendNotificationResponse": {
                "fields": {}
              },
              "CardAssignment": {
                "fields": {
                  "cardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardInvitationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SearchCardAssignmentsRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsQuery",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CardAssignmentsFilter": {
                    "fields": {
                      "cardTokens": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "CardAssignmentsQuery": {
                    "fields": {
                      "filter": {
                        "type": ".squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsFilter",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SearchCardAssignmentsResponse": {
                "fields": {
                  "assignments": {
                    "type": ".squareup.bizbank.service.CardAssignment",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ListCardsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeAdditionalDetails": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": ".squareup.bizbank.service.ListCardsRequest.Filters",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": ".squareup.bizbank.service.ListCardsRequest.SortOrder",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "ASC"
                    }
                  }
                },
                "nested": {
                  "SortOrder": {
                    "values": {
                      "ASC": 1,
                      "DESC": 2
                    }
                  },
                  "Filters": {
                    "fields": {
                      "includedCardTypes": {
                        "type": ".squareup.bizbank.service.CardData.CardType",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "ListCardsResponse": {
                "fields": {
                  "cards": {
                    "type": ".squareup.bizbank.service.CardData",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "CardBrand": {
                "values": {
                  "VISA": 1,
                  "MASTERCARD": 2
                }
              },
              "CardData": {
                "fields": {
                  "cardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "banklinCardToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "cardState": {
                    "type": ".squareup.bizbank.service.CardData.CardState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardBrand": {
                    "type": ".squareup.bizbank.service.CardBrand",
                    "id": 3,
                    "rule": "optional"
                  },
                  "panLastFour": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "nameOnCard": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "active2faTokenTypes": {
                    "type": ".squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "shippingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 7,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 8,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 9,
                    "rule": "optional"
                  },
                  "cardType": {
                    "type": ".squareup.bizbank.service.CardData.CardType",
                    "id": 10,
                    "rule": "optional"
                  },
                  "deactivationReason": {
                    "type": ".squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cardEvents": {
                    "type": ".squareup.banklin.CardEvent",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "isActivatable": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "customizationToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CardState": {
                    "values": {
                      "ACTIVE": 1,
                      "DISABLED": 2,
                      "TERMINATED": 3,
                      "SUSPENDED": 4,
                      "VERIFIED": 5,
                      "ISSUED": 6,
                      "UNDELIVERABLE": 7,
                      "SHIPPED": 8,
                      "CANCELLED": 9,
                      "REJECTED": 10,
                      "DESTROYED": 11,
                      "ACTIVE_PENDING_2FA": 12,
                      "REVIEW_PENDING": 13,
                      "CUSTOMIZATION_APPROVED": 14,
                      "CUSTOMIZATION_DENIED": 15
                    }
                  },
                  "CardType": {
                    "values": {
                      "PHYSICAL": 1,
                      "VIRTUAL": 2
                    }
                  }
                }
              },
              "CardActivity": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "activityType": {
                    "type": ".squareup.bizbank.service.CardActivity.ActivityType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transactionState": {
                    "type": ".squareup.banklin.TransactionState",
                    "id": 5,
                    "rule": "optional"
                  },
                  "occurredAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 6,
                    "rule": "optional"
                  },
                  "activityDisplayString": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "declineReason": {
                    "type": ".squareup.banklin.octopus.OctopusResult",
                    "id": 12,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 13,
                    "rule": "optional"
                  },
                  "moneyTransferServerToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "cardInfo": {
                    "type": ".squareup.bizbank.service.CardActivity.DepositCardInfo",
                    "id": 9
                  },
                  "bankInfo": {
                    "type": ".squareup.bizbank.service.CardActivity.DepositBankInfo",
                    "id": 10
                  }
                },
                "nested": {
                  "ActivityType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CARD_PAYMENT": 1,
                      "DEPOSIT": 2,
                      "INSTANT_DEPOSIT": 3,
                      "INSTANT_DEPOSIT_FEE": 4,
                      "ATM_WITHDRAWAL": 5,
                      "ATM_WITHDRAWAL_FEE": 6,
                      "CARD_PAYMENT_REWARD": 7
                    }
                  },
                  "DepositCardInfo": {
                    "fields": {
                      "cardBrand": {
                        "type": ".squareup.common.instrument.InstrumentType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "panSuffix": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cardToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "DepositBankInfo": {
                    "fields": {
                      "bankName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "bankAccountSuffix": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "bankAccountToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "deposit_info": {
                    "oneof": [
                      "cardInfo",
                      "bankInfo"
                    ]
                  }
                }
              },
              "ProvideFeedbackRequest": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "feedbackText": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "feedbackSource": {
                    "type": ".squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "FeedbackSource": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CARD_DEACTIVATION": 1,
                      "BALANCE_DEACTIVATION": 2,
                      "ACCOUNT_DEACTIVATION_REGULATOR": 3,
                      "TRANSFER_OF_ACCOUNT": 4,
                      "ADMIN_CONSOLE": 5,
                      "ACCOUNT_DEACTIVATION_BANK_PARTNER": 6,
                      "ACCOUNT_DEACTIVATION_RISK_TEAM": 7
                    }
                  }
                }
              },
              "ProvisionDigitalWalletTokenRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "provisioningAppVersion": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "deviceType": {
                    "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.DeviceType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "applePayRequest": {
                    "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.ApplePayRequest",
                    "id": 5
                  },
                  "googlePayRequest": {
                    "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.GooglePayRequest",
                    "id": 6
                  }
                },
                "nested": {
                  "DeviceType": {
                    "values": {
                      "UNKNOWN": 1,
                      "MOBILE_PHONE": 2,
                      "WATCH": 3
                    }
                  },
                  "ApplePayRequest": {
                    "fields": {
                      "certificates": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "nonce": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "nonceSignature": {
                        "type": "bytes",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "GooglePayRequest": {
                    "fields": {
                      "walletAccountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "deviceId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Request": {
                    "oneof": [
                      "applePayRequest",
                      "googlePayRequest"
                    ]
                  }
                }
              },
              "ProvisionDigitalWalletTokenResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "applePayResponse": {
                    "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.ApplePayResponse",
                    "id": 2
                  },
                  "googlePayResponse": {
                    "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.GooglePayResponse",
                    "id": 3
                  }
                },
                "nested": {
                  "ApplePayResponse": {
                    "fields": {
                      "encryptedPassData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "activationData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ephemeralPublicKey": {
                        "type": "bytes",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "GooglePayResponse": {
                    "fields": {
                      "opaquePaymentCard": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "Response": {
                    "oneof": [
                      "applePayResponse",
                      "googlePayResponse"
                    ]
                  }
                }
              },
              "ProvideFeedbackResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SetCardBillingAddressRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetCardBillingAddressResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.bizbank.service.SetCardBillingAddressResponse.FailureReason",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "FailureReason": {
                    "values": {
                      "NO_FAILURE": 0,
                      "NO_BIZBANK_USER_FOUND": 1,
                      "ADDRESS_IS_PO_BOX": 2,
                      "ADDRESS_IS_INVALID": 3,
                      "MARQETA_VERIFICATION_ERROR": 4
                    }
                  }
                }
              },
              "SetEnabledRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "enabled": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetEnabledResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SetPasscodeRequest": {
                "fields": {
                  "passcode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "authenticationToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "SetPasscodeResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.bizbank.service.SetPasscodeResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "SUCCESS": 1,
                      "FAILED": 2,
                      "INVALID_CARD_TOKEN": 3,
                      "FAILED_WEAK_PASSCODE": 4,
                      "AUTHENTICATION_TOKEN_INVALID": 5,
                      "AUTHENTICATION_TOKEN_EXPIRED": 6
                    }
                  }
                }
              },
              "StartCardActivationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "StartCardActivationResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "StartIdentityVerificationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ownerAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ownerBirthDate": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ownerSocialSecurityNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "StartIdentityVerificationResponse": {
                "fields": {
                  "pollToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "StartIssueCardRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "StartIssueCardResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardIssueToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "normalizedAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 4,
                    "rule": "optional"
                  },
                  "addressNormalizationResult": {
                    "type": ".squareup.bizbank.service.StartIssueCardResponse.AddressNormalizationResult",
                    "id": 5,
                    "rule": "optional"
                  },
                  "correctedField": {
                    "type": ".squareup.solidshop.VerifyShippingAddressResponse.CorrectedField",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "challengeRequested": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                },
                "nested": {
                  "AddressNormalizationResult": {
                    "values": {
                      "SUCCESS": 1,
                      "VERIFICATION_NOT_AVAILABLE": 2,
                      "VERIFICATION_FAILED": 3,
                      "UNKNOWN_ERROR": 4
                    }
                  }
                }
              },
              "TwoFactorAuthenticationRequestType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "CARD_ACTIVATION": 1,
                  "RESET_PASSCODE": 2,
                  "SHOW_PRIVATE_CARD_DATA": 3,
                  "SHOW_DIRECT_DEPOSIT_ACCOUNT": 4
                }
              },
              "StartTwoFactorAuthenticationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "requestType": {
                    "type": ".squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "StartTwoFactorAuthenticationResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ToggleCardRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "enableCard": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ToggleCardResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "card": {
                    "type": ".squareup.bizbank.service.CardData",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "VerifyCardActivationTokenRequest": {
                "fields": {
                  "activationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "VerifyCardActivationTokenResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.bizbank.service.VerifyCardActivationTokenResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "VERIFIED": 1,
                      "INVALID_TOKEN": 2,
                      "EXPIRED_TOKEN": 3,
                      "USED": 4,
                      "FAILED": 5
                    }
                  }
                }
              },
              "VerifyTwoFactorAuthenticationTokenRequest": {
                "fields": {
                  "authenticationToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "requestType": {
                    "type": ".squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "VerifyTwoFactorAuthenticationTokenResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "VERIFIED": 1,
                      "INVALID_TOKEN": 2,
                      "EXPIRED_TOKEN": 3
                    }
                  }
                }
              },
              "VoidAuthorizationRequest": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "VoidAuthorizationResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "IdvState": {
                "values": {
                  "IDV_DO_NOT_USE": 0,
                  "APPROVED": 1,
                  "INCOMPLETE": 2
                }
              },
              "GetFundsHoldingAccountRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1
                  },
                  "balanceToken": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "customer_token": {
                    "oneof": [
                      "unitToken",
                      "balanceToken"
                    ]
                  }
                }
              },
              "GetFundsHoldingAccountResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": ".squareup.common.countries.Country",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetIsUserAuthorizedRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "loggableSessionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetIsUserAuthorizedResponse": {
                "fields": {
                  "isAuthorized": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetPromotionalRewardDescriptionRequest": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetPromotionalRewardDescriptionResponse": {
                "fields": {
                  "description": {
                    "type": "string",
                    "id": 1
                  },
                  "error": {
                    "type": ".squareup.bizbank.service.GetPromotionalRewardDescriptionResponse.Error",
                    "id": 2
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "TRANSACTION_NOT_FOUND": 1,
                      "INVALID_TRANSACTION_TOKEN": 2
                    }
                  },
                  "result": {
                    "oneof": [
                      "description",
                      "error"
                    ]
                  }
                }
              },
              "LookupUnitRequest": {
                "fields": {
                  "panFideliusToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "LookupUnitResponse": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "balance": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListDisputedTransactionTokensRequest": {
                "fields": {
                  "transactionTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ListDisputedTransactionTokensResponse": {
                "fields": {
                  "disputedTransactionTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ValidateAddressRequest": {
                "fields": {
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ValidateAddressResponse": {
                "fields": {
                  "normalizedAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  },
                  "addressNormalizationResult": {
                    "type": ".squareup.bizbank.service.ValidateAddressResponse.AddressNormalizationResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "correctedFields": {
                    "type": ".squareup.bizbank.service.ValidateAddressResponse.CorrectedField",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CorrectedField": {
                    "values": {
                      "DO_NOT_USE_FIELD": 0,
                      "ADDRESS_LINE_1": 1,
                      "ADDRESS_LINE_2": 2,
                      "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                      "LOCALITY": 4,
                      "POSTAL_CODE": 5
                    }
                  },
                  "AddressNormalizationResult": {
                    "values": {
                      "DO_NOT_USE_RESULT": 0,
                      "SUCCESS": 1,
                      "VERIFICATION_NOT_AVAILABLE": 2,
                      "VERIFICATION_FAILED": 3,
                      "UNKNOWN_ERROR": 4
                    }
                  }
                }
              },
              "UpdateCustomerDataRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1
                  },
                  "banklinToken": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "customer_token": {
                    "oneof": [
                      "unitToken",
                      "banklinToken"
                    ]
                  }
                }
              },
              "UpdateCustomerDataResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetCustomizationSettingsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "userAgent": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetCustomizationSettingsResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ownerName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "minInkCoverage": {
                    "type": "float",
                    "id": 4,
                    "rule": "optional"
                  },
                  "maxInkCoverage": {
                    "type": "float",
                    "id": 5,
                    "rule": "optional"
                  },
                  "idvState": {
                    "type": ".squareup.bizbank.service.IdvState",
                    "id": 6,
                    "rule": "optional"
                  },
                  "canRetryIdv": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "ownerAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 8,
                    "rule": "optional"
                  },
                  "ownerBirthDate": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 9,
                    "rule": "optional"
                  },
                  "idvNeedsSsn": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "idvRetriesRemaining": {
                    "type": "int32",
                    "id": 11,
                    "rule": "optional"
                  },
                  "ineligibilityReason": {
                    "type": ".squareup.bizbank.service.GetCustomizationSettingsResponse.IneligibilityReason",
                    "id": 12,
                    "rule": "optional"
                  },
                  "existingCustomization": {
                    "type": ".squareup.bizbank.service.GetCustomizationSettingsResponse.ExistingCustomization",
                    "id": 13,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "IneligibilityReason": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "NOT_ELIGIBLE": 1,
                      "EXHAUSTED_IDV_RETRIES": 2,
                      "NOT_ACTIVATED": 3
                    }
                  },
                  "ExistingCustomization": {
                    "fields": {
                      "trunkToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "imageBytes": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "mimeType": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetAllStampsRequest": {
                "fields": {}
              },
              "GetAllStampsResponse": {
                "fields": {
                  "stamps": {
                    "type": ".squareup.bizbank.service.Stamp",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "Stamp": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accessibilityText": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "svg": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "minScale": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "GetFontsRequest": {
                "fields": {}
              },
              "GetFontsResponse": {
                "fields": {
                  "fonts": {
                    "type": ".squareup.bizbank.service.GetFontsResponse.Font",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Font": {
                    "fields": {
                      "fontFamily": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fontUrl": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "DeactivateAccountRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deactivationReason": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource",
                    "id": 3,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "DeactivateAccountResponse": {
                "fields": {}
              },
              "MerchantBlockState": {
                "values": {
                  "UNKNOWN_MERCHANT_BLOCK_STATE": 0,
                  "BLOCKED": 1,
                  "UNBLOCKED": 2
                }
              },
              "UpdateMerchantBlockRequest": {
                "fields": {
                  "merchanteinMerchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantBlockState": {
                    "type": ".squareup.bizbank.service.MerchantBlockState",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantBlockResponse": {
                "fields": {
                  "merchantBlockState": {
                    "type": ".squareup.bizbank.service.MerchantBlockState",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetMerchantBlockRequest": {
                "fields": {
                  "merchanteinMerchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetMerchantBlockResponse": {
                "fields": {
                  "merchantBlockState": {
                    "type": ".squareup.bizbank.service.MerchantBlockState",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListMerchantBlocksRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListMerchantBlocksResponse": {
                "fields": {
                  "blockedMerchanteinMerchants": {
                    "type": ".squareup.bizbank.service.ListMerchantBlocksResponse.MerchanteinMerchant",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "MerchanteinMerchant": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "merchantImage": {
                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "BizbankService": {
                "methods": {
                  "AddMobileNumberForSmsNotifications": {
                    "requestType": ".squareup.bizbank.service.AddMobileNumberForSmsNotificationsRequest",
                    "responseType": ".squareup.bizbank.service.AddMobileNumberForSmsNotificationsResponse"
                  },
                  "ConfirmIssueCard": {
                    "requestType": ".squareup.bizbank.service.ConfirmIssueCardRequest",
                    "responseType": ".squareup.bizbank.service.ConfirmIssueCardResponse"
                  },
                  "CheckIdentityVerificationStatus": {
                    "requestType": ".squareup.bizbank.service.CheckIdentityVerificationStatusRequest",
                    "responseType": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse"
                  },
                  "LedgerDisputeLost": {
                    "requestType": ".squareup.bizbank.transaction_dispute.LedgerDisputeLostRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.LedgerDisputeLostResponse"
                  },
                  "CreateCardCustomization": {
                    "requestType": ".squareup.bizbank.service.CreateCardCustomizationRequest",
                    "responseType": ".squareup.bizbank.service.CreateCardCustomizationResponse"
                  },
                  "CreateMarqetaDispute": {
                    "requestType": ".squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.CreateMarqetaDisputeResponse"
                  },
                  "CreateTransactionDispute": {
                    "requestType": ".squareup.bizbank.transaction_dispute.CreateTransactionDisputeRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.CreateTransactionDisputeResponse"
                  },
                  "CreateUserAuthorization": {
                    "requestType": ".squareup.bizbank.card_management.CreateUserAuthorizationRequest",
                    "responseType": ".squareup.bizbank.card_management.CreateUserAuthorizationResponse"
                  },
                  "DeactivateAccount": {
                    "requestType": ".squareup.bizbank.service.DeactivateAccountRequest",
                    "responseType": ".squareup.bizbank.service.DeactivateAccountResponse"
                  },
                  "DeactivateCard": {
                    "requestType": ".squareup.bizbank.service.DeactivateCardRequest",
                    "responseType": ".squareup.bizbank.service.DeactivateCardResponse"
                  },
                  "ExpireAllUserAuthorizations": {
                    "requestType": ".squareup.bizbank.card_management.ExpireAllUserAuthorizationsRequest",
                    "responseType": ".squareup.bizbank.card_management.ExpireAllUserAuthorizationsResponse"
                  },
                  "FinishCardActivation": {
                    "requestType": ".squareup.bizbank.service.FinishCardActivationRequest",
                    "responseType": ".squareup.bizbank.service.FinishCardActivationResponse"
                  },
                  "EnqueueSweep": {
                    "requestType": ".squareup.bizbank.service.EnqueueSweepRequest",
                    "responseType": ".squareup.bizbank.service.EnqueueSweepResponse"
                  },
                  "GetAtmLimits": {
                    "requestType": ".squareup.bizbank.service.GetAtmLimitsRequest",
                    "responseType": ".squareup.bizbank.service.GetAtmLimitsResponse"
                  },
                  "GetBalance": {
                    "requestType": ".squareup.bizbank.service.GetBalanceRequest",
                    "responseType": ".squareup.bizbank.service.GetBalanceResponse"
                  },
                  "GetBalanceOverview": {
                    "requestType": ".squareup.bizbank.unified_activity.GetBalanceOverviewRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetBalanceOverviewResponse"
                  },
                  "GetPaymentProcessingDetails": {
                    "requestType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsResponse"
                  },
                  "GetBizbankAccount": {
                    "requestType": ".squareup.bizbank.service.GetBizbankAccountRequest",
                    "responseType": ".squareup.bizbank.service.GetBizbankAccountResponse"
                  },
                  "GetCardActivity": {
                    "requestType": ".squareup.bizbank.service.GetCardActivityRequest",
                    "responseType": ".squareup.bizbank.service.GetCardActivityResponse"
                  },
                  "GetCardCustomization": {
                    "requestType": ".squareup.bizbank.service.GetCardCustomizationRequest",
                    "responseType": ".squareup.bizbank.service.GetCardCustomizationResponse"
                  },
                  "GetCardOrderingEligibility": {
                    "requestType": ".squareup.bizbank.service.GetCardOrderingEligibilityRequest",
                    "responseType": ".squareup.bizbank.service.GetCardOrderingEligibilityResponse"
                  },
                  "GetDigitalWalletToken": {
                    "requestType": ".squareup.bizbank.service.GetDigitalWalletTokenRequest",
                    "responseType": ".squareup.bizbank.service.GetDigitalWalletTokenResponse"
                  },
                  "GetDigitalWalletTokensForUnit": {
                    "requestType": ".squareup.bizbank.service.GetDigitalWalletTokensForUnitRequest",
                    "responseType": ".squareup.bizbank.service.GetDigitalWalletTokensForUnitResponse"
                  },
                  "GetFundsHoldingAccount": {
                    "requestType": ".squareup.bizbank.service.GetFundsHoldingAccountRequest",
                    "responseType": ".squareup.bizbank.service.GetFundsHoldingAccountResponse"
                  },
                  "GetPrivateCardData": {
                    "requestType": ".squareup.bizbank.card_management.GetPrivateCardDataRequest",
                    "responseType": ".squareup.bizbank.card_management.GetPrivateCardDataResponse"
                  },
                  "GetEnabled": {
                    "requestType": ".squareup.bizbank.service.GetEnabledRequest",
                    "responseType": ".squareup.bizbank.service.GetEnabledResponse"
                  },
                  "GetEnabledHistory": {
                    "requestType": ".squareup.bizbank.service.GetEnabledHistoryRequest",
                    "responseType": ".squareup.bizbank.service.GetEnabledHistoryResponse"
                  },
                  "GetFonts": {
                    "requestType": ".squareup.bizbank.service.GetFontsRequest",
                    "responseType": ".squareup.bizbank.service.GetFontsResponse"
                  },
                  "GetCardBillingAddress": {
                    "requestType": ".squareup.bizbank.service.GetCardBillingAddressRequest",
                    "responseType": ".squareup.bizbank.service.GetCardBillingAddressResponse"
                  },
                  "GetRolledUpActivity": {
                    "requestType": ".squareup.bizbank.service.GetRolledUpActivityRequest",
                    "responseType": ".squareup.bizbank.service.GetRolledUpActivityResponse"
                  },
                  "GetSpendingLimits": {
                    "requestType": ".squareup.bizbank.service.GetSpendingLimitsRequest",
                    "responseType": ".squareup.bizbank.service.GetSpendingLimitsResponse"
                  },
                  "GetUnifiedActivities": {
                    "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse"
                  },
                  "GetUnifiedActivityDetails": {
                    "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse"
                  },
                  "GetUnifiedActivityEvents": {
                    "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsResponse"
                  },
                  "GetUnifiedActivityEventDetails": {
                    "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsResponse"
                  },
                  "GetUnifiedActivityTransitionData": {
                    "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse"
                  },
                  "GetIsUserAuthorized": {
                    "requestType": ".squareup.bizbank.service.GetIsUserAuthorizedRequest",
                    "responseType": ".squareup.bizbank.service.GetIsUserAuthorizedResponse"
                  },
                  "HandleDisputeStatusUpdateEvent": {
                    "requestType": ".squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventResponse"
                  },
                  "ListCards": {
                    "requestType": ".squareup.bizbank.service.ListCardsRequest",
                    "responseType": ".squareup.bizbank.service.ListCardsResponse"
                  },
                  "GetTransactionDispute": {
                    "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeResponse"
                  },
                  "GetTransactionDisputeByTransactionToken": {
                    "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenResponse"
                  },
                  "GetTransactionDisputeActivity": {
                    "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse"
                  },
                  "IssueCard": {
                    "requestType": ".squareup.bizbank.service.IssueCardRequest",
                    "responseType": ".squareup.bizbank.service.IssueCardResponse"
                  },
                  "CreateCardInvitation": {
                    "requestType": ".squareup.bizbank.service.CreateCardInvitationRequest",
                    "responseType": ".squareup.bizbank.service.CreateCardInvitationResponse"
                  },
                  "SendNotification": {
                    "requestType": ".squareup.bizbank.service.SendNotificationRequest",
                    "responseType": ".squareup.bizbank.service.SendNotificationResponse"
                  },
                  "SearchCardAssignments": {
                    "requestType": ".squareup.bizbank.service.SearchCardAssignmentsRequest",
                    "responseType": ".squareup.bizbank.service.SearchCardAssignmentsResponse"
                  },
                  "ListTransactionDisputes": {
                    "requestType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse"
                  },
                  "ListDisputedTransactionTokens": {
                    "requestType": ".squareup.bizbank.service.ListDisputedTransactionTokensRequest",
                    "responseType": ".squareup.bizbank.service.ListDisputedTransactionTokensResponse"
                  },
                  "ListTransactionDisputeStatusUpdates": {
                    "requestType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse"
                  },
                  "LookupUnit": {
                    "requestType": ".squareup.bizbank.service.LookupUnitRequest",
                    "responseType": ".squareup.bizbank.service.LookupUnitResponse"
                  },
                  "ProvideFeedback": {
                    "requestType": ".squareup.bizbank.service.ProvideFeedbackRequest",
                    "responseType": ".squareup.bizbank.service.ProvideFeedbackResponse"
                  },
                  "ProvisionDigitalWalletToken": {
                    "requestType": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest",
                    "responseType": ".squareup.bizbank.service.ProvisionDigitalWalletTokenResponse"
                  },
                  "SetCardBillingAddress": {
                    "requestType": ".squareup.bizbank.service.SetCardBillingAddressRequest",
                    "responseType": ".squareup.bizbank.service.SetCardBillingAddressResponse"
                  },
                  "SetEnabled": {
                    "requestType": ".squareup.bizbank.service.SetEnabledRequest",
                    "responseType": ".squareup.bizbank.service.SetEnabledResponse"
                  },
                  "SetPasscode": {
                    "requestType": ".squareup.bizbank.service.SetPasscodeRequest",
                    "responseType": ".squareup.bizbank.service.SetPasscodeResponse"
                  },
                  "StartCardActivation": {
                    "requestType": ".squareup.bizbank.service.StartCardActivationRequest",
                    "responseType": ".squareup.bizbank.service.StartCardActivationResponse"
                  },
                  "StartIdentityVerification": {
                    "requestType": ".squareup.bizbank.service.StartIdentityVerificationRequest",
                    "responseType": ".squareup.bizbank.service.StartIdentityVerificationResponse"
                  },
                  "StartIssueCard": {
                    "requestType": ".squareup.bizbank.service.StartIssueCardRequest",
                    "responseType": ".squareup.bizbank.service.StartIssueCardResponse"
                  },
                  "StartTwoFactorAuthentication": {
                    "requestType": ".squareup.bizbank.service.StartTwoFactorAuthenticationRequest",
                    "responseType": ".squareup.bizbank.service.StartTwoFactorAuthenticationResponse"
                  },
                  "ToggleCard": {
                    "requestType": ".squareup.bizbank.service.ToggleCardRequest",
                    "responseType": ".squareup.bizbank.service.ToggleCardResponse"
                  },
                  "UpdateCustomerData": {
                    "requestType": ".squareup.bizbank.service.UpdateCustomerDataRequest",
                    "responseType": ".squareup.bizbank.service.UpdateCustomerDataResponse"
                  },
                  "UpdateTransactionDispute": {
                    "requestType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeResponse"
                  },
                  "UpdateTransactionDisputeByTransactionToken": {
                    "requestType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeByTransactionTokenRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeResponse"
                  },
                  "UpdateDeactivationReason": {
                    "requestType": ".squareup.bizbank.service.UpdateDeactivationReasonRequest",
                    "responseType": ".squareup.bizbank.service.UpdateDeactivationReasonResponse"
                  },
                  "ValidateAddress": {
                    "requestType": ".squareup.bizbank.service.ValidateAddressRequest",
                    "responseType": ".squareup.bizbank.service.ValidateAddressResponse"
                  },
                  "VerifyCardActivationToken": {
                    "requestType": ".squareup.bizbank.service.VerifyCardActivationTokenRequest",
                    "responseType": ".squareup.bizbank.service.VerifyCardActivationTokenResponse"
                  },
                  "VerifyTwoFactorAuthenticationToken": {
                    "requestType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest",
                    "responseType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse"
                  },
                  "VoidAuthorization": {
                    "requestType": ".squareup.bizbank.service.VoidAuthorizationRequest",
                    "responseType": ".squareup.bizbank.service.VoidAuthorizationResponse"
                  },
                  "GetPromotionalRewardDescription": {
                    "requestType": ".squareup.bizbank.service.GetPromotionalRewardDescriptionRequest",
                    "responseType": ".squareup.bizbank.service.GetPromotionalRewardDescriptionResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.AddMobileNumberForSmsNotificationsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.AddMobileNumberForSmsNotificationsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Response && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Pending && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.IdvError && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ConfirmIssueCardRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ConfirmIssueCardResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IssueCardRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IssueCardRequest?.nested?.PhysicalCardDetails && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IssueCardResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardCustomizationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardCustomizationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardRequest?.nested?.DeactivationReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateDeactivationReasonRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateDeactivationReasonResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateDeactivationReasonResponse?.nested?.UpdateDeactivationReasonError && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationResponse?.nested?.Result && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.EnqueueSweepRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.EnqueueSweepResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBalanceRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBalanceResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBizbankAccountRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBizbankAccountResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBizbankAccountResponse?.nested?.BizbankAccount && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UnitIneligibilityReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardOrderingEligibilityRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardOrderingEligibilityResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest?.nested?.Filters && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest?.nested?.Filters?.nested?.DateSource && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityResponse?.nested?.BatchResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardCustomizationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardCustomization && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardCustomizationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledResponse?.nested?.EnabledAttribute && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledHistoryRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledHistoryResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledHistoryResponse?.nested?.DateTimeIntervals && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardBillingAddressRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardBillingAddressResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DigitalWalletToken && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokenRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokenResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokensForUnitRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokensForUnitResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest?.nested?.SortOrder && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest?.nested?.RolledUpActivityType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest?.nested?.Filters && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse?.nested?.Fee && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse?.nested?.Fee?.nested?.FeeType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse?.nested?.RolledUpCardActivity && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendLimit && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendLimit?.nested?.Cadence && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendLimit?.nested?.CardType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsResponse?.nested?.Limit && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsResponse?.nested?.Limit?.nested?.Cadence && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardInvitationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardInvitationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SendNotificationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SendNotificationRequest?.nested?.CardInvitationEmailPayload && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SendNotificationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardAssignment && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsRequest?.nested?.CardAssignmentsFilter && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsRequest?.nested?.CardAssignmentsQuery && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest?.nested?.SortOrder && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest?.nested?.Filters && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardBrand && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData?.nested?.CardState && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData?.nested?.CardType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.ActivityType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.DepositCardInfo && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.DepositBankInfo && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackRequest?.nested?.FeedbackSource && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest?.nested?.DeviceType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest?.nested?.ApplePayRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest?.nested?.GooglePayRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenResponse?.nested?.ApplePayResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenResponse?.nested?.GooglePayResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressResponse?.nested?.FailureReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetEnabledRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetEnabledResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeResponse?.nested?.Result && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartCardActivationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartCardActivationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIdentityVerificationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIdentityVerificationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardResponse?.nested?.AddressNormalizationResult && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.TwoFactorAuthenticationRequestType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartTwoFactorAuthenticationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartTwoFactorAuthenticationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ToggleCardRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ToggleCardResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenResponse?.nested?.Result && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenResponse?.nested?.Result && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VoidAuthorizationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VoidAuthorizationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IdvState && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFundsHoldingAccountRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFundsHoldingAccountResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetIsUserAuthorizedRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetIsUserAuthorizedResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetPromotionalRewardDescriptionRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetPromotionalRewardDescriptionResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetPromotionalRewardDescriptionResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.LookupUnitRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.LookupUnitResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListDisputedTransactionTokensRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListDisputedTransactionTokensResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse?.nested?.CorrectedField && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse?.nested?.AddressNormalizationResult && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateCustomerDataRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateCustomerDataResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse?.nested?.IneligibilityReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse?.nested?.ExistingCustomization && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAllStampsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAllStampsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.Stamp && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFontsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFontsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFontsResponse?.nested?.Font && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateAccountRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateAccountResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.MerchantBlockState && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateMerchantBlockRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateMerchantBlockResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetMerchantBlockRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetMerchantBlockResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksResponse?.nested?.MerchanteinMerchant && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.BizbankService) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE AddMobileNumberForSmsNotificationsRequest @ squareup/bizbank/service.proto at 52:1
 */
export const AddMobileNumberForSmsNotificationsRequest = $root.lookupType('squareup.bizbank.service.AddMobileNumberForSmsNotificationsRequest');
fixType(AddMobileNumberForSmsNotificationsRequest);
Builder.createAndAttachToType(AddMobileNumberForSmsNotificationsRequest);
/**
 * SOURCE AddMobileNumberForSmsNotificationsResponse @ squareup/bizbank/service.proto at 59:1
 */
export const AddMobileNumberForSmsNotificationsResponse = $root.lookupType('squareup.bizbank.service.AddMobileNumberForSmsNotificationsResponse');
fixType(AddMobileNumberForSmsNotificationsResponse);
Builder.createAndAttachToType(AddMobileNumberForSmsNotificationsResponse);
/**
 * SOURCE CheckIdentityVerificationStatusRequest @ squareup/bizbank/service.proto at 65:1
 */
export const CheckIdentityVerificationStatusRequest = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusRequest');
fixType(CheckIdentityVerificationStatusRequest, {
  unitToken: { required: true },
});
Builder.createAndAttachToType(CheckIdentityVerificationStatusRequest);
/**
 * SOURCE CheckIdentityVerificationStatusResponse @ squareup/bizbank/service.proto at 70:1
 */
export const CheckIdentityVerificationStatusResponse = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse');
fixType(CheckIdentityVerificationStatusResponse);
Builder.createAndAttachToType(CheckIdentityVerificationStatusResponse);
/**
 * SOURCE Response @ squareup/bizbank/service.proto at 71:3
 */
CheckIdentityVerificationStatusResponse.Response = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Response');
fixType(CheckIdentityVerificationStatusResponse.Response);
Builder.createAndAttachToType(CheckIdentityVerificationStatusResponse.Response);
/**
 * SOURCE Pending @ squareup/bizbank/service.proto at 82:3
 */
CheckIdentityVerificationStatusResponse.Pending = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Pending');
fixType(CheckIdentityVerificationStatusResponse.Pending);
Builder.createAndAttachToType(CheckIdentityVerificationStatusResponse.Pending);
/**
 * SOURCE IdvError @ squareup/bizbank/service.proto at 86:3
 */
CheckIdentityVerificationStatusResponse.IdvError = $root.lookupEnum('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.IdvError').values;
/**
 * SOURCE Error @ squareup/bizbank/service.proto at 94:3
 */
CheckIdentityVerificationStatusResponse.Error = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Error');
fixType(CheckIdentityVerificationStatusResponse.Error);
Builder.createAndAttachToType(CheckIdentityVerificationStatusResponse.Error);
/**
 * SOURCE ConfirmIssueCardRequest @ squareup/bizbank/service.proto at 106:1
 */
export const ConfirmIssueCardRequest = $root.lookupType('squareup.bizbank.service.ConfirmIssueCardRequest');
fixType(ConfirmIssueCardRequest, {
  unitToken: { notEmpty: true },
  cardIssueToken: { notEmpty: true },
  shippingAddress: { required: true },
});
Builder.createAndAttachToType(ConfirmIssueCardRequest);
/**
 * SOURCE ConfirmIssueCardResponse @ squareup/bizbank/service.proto at 121:1
 */
export const ConfirmIssueCardResponse = $root.lookupType('squareup.bizbank.service.ConfirmIssueCardResponse');
fixType(ConfirmIssueCardResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(ConfirmIssueCardResponse);
/**
 * SOURCE IssueCardRequest @ squareup/bizbank/service.proto at 128:1
 */
export const IssueCardRequest = $root.lookupType('squareup.bizbank.service.IssueCardRequest');
fixType(IssueCardRequest, {
  unitToken: { notEmpty: true },
  createPhysicalCard: { required: true },
  createVirtualCard: { required: true },
  idempotenceKey: { required: true },
});
Builder.createAndAttachToType(IssueCardRequest);
/**
 * SOURCE PhysicalCardDetails @ squareup/bizbank/service.proto at 129:3
 */
IssueCardRequest.PhysicalCardDetails = $root.lookupType('squareup.bizbank.service.IssueCardRequest.PhysicalCardDetails');
fixType(IssueCardRequest.PhysicalCardDetails, {
  firstName: { notEmpty: true },
  lastName: { notEmpty: true },
  shippingAddress: { required: true },
});
Builder.createAndAttachToType(IssueCardRequest.PhysicalCardDetails);
/**
 * SOURCE IssueCardResponse @ squareup/bizbank/service.proto at 146:1
 */
export const IssueCardResponse = $root.lookupType('squareup.bizbank.service.IssueCardResponse');
fixType(IssueCardResponse);
Builder.createAndAttachToType(IssueCardResponse);
/**
 * SOURCE CreateCardCustomizationRequest @ squareup/bizbank/service.proto at 156:1
 */
export const CreateCardCustomizationRequest = $root.lookupType('squareup.bizbank.service.CreateCardCustomizationRequest');
fixType(CreateCardCustomizationRequest, {
  idempotenceKey: { notEmpty: true },
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(CreateCardCustomizationRequest);
/**
 * SOURCE CreateCardCustomizationResponse @ squareup/bizbank/service.proto at 165:1
 */
export const CreateCardCustomizationResponse = $root.lookupType('squareup.bizbank.service.CreateCardCustomizationResponse');
fixType(CreateCardCustomizationResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(CreateCardCustomizationResponse);
/**
 * SOURCE DeactivateCardRequest @ squareup/bizbank/service.proto at 170:1
 */
export const DeactivateCardRequest = $root.lookupType('squareup.bizbank.service.DeactivateCardRequest');
fixType(DeactivateCardRequest, {
  unitToken: { notEmpty: true },
  cardToken: { notEmpty: true },
});
Builder.createAndAttachToType(DeactivateCardRequest);
/**
 * SOURCE DeactivationReason @ squareup/bizbank/service.proto at 171:3
 */
DeactivateCardRequest.DeactivationReason = $root.lookupEnum('squareup.bizbank.service.DeactivateCardRequest.DeactivationReason').values;
/**
 * SOURCE DeactivateCardResponse @ squareup/bizbank/service.proto at 190:1
 */
export const DeactivateCardResponse = $root.lookupType('squareup.bizbank.service.DeactivateCardResponse');
fixType(DeactivateCardResponse, {
  success: { required: true },
  bizbankEnabled: { required: true },
});
Builder.createAndAttachToType(DeactivateCardResponse);
/**
 * SOURCE UpdateDeactivationReasonRequest @ squareup/bizbank/service.proto at 196:1
 */
export const UpdateDeactivationReasonRequest = $root.lookupType('squareup.bizbank.service.UpdateDeactivationReasonRequest');
fixType(UpdateDeactivationReasonRequest, {
  cardToken: { notEmpty: true },
  reason: { required: true },
});
Builder.createAndAttachToType(UpdateDeactivationReasonRequest);
/**
 * SOURCE UpdateDeactivationReasonResponse @ squareup/bizbank/service.proto at 201:1
 */
export const UpdateDeactivationReasonResponse = $root.lookupType('squareup.bizbank.service.UpdateDeactivationReasonResponse');
fixType(UpdateDeactivationReasonResponse);
Builder.createAndAttachToType(UpdateDeactivationReasonResponse);
/**
 * SOURCE UpdateDeactivationReasonError @ squareup/bizbank/service.proto at 204:3
 */
UpdateDeactivationReasonResponse.UpdateDeactivationReasonError = $root.lookupEnum('squareup.bizbank.service.UpdateDeactivationReasonResponse.UpdateDeactivationReasonError').values;
/**
 * SOURCE FinishCardActivationRequest @ squareup/bizbank/service.proto at 210:1
 */
export const FinishCardActivationRequest = $root.lookupType('squareup.bizbank.service.FinishCardActivationRequest');
fixType(FinishCardActivationRequest);
Builder.createAndAttachToType(FinishCardActivationRequest);
/**
 * SOURCE FinishCardActivationResponse @ squareup/bizbank/service.proto at 222:1
 */
export const FinishCardActivationResponse = $root.lookupType('squareup.bizbank.service.FinishCardActivationResponse');
fixType(FinishCardActivationResponse, {
  result: { required: true },
});
Builder.createAndAttachToType(FinishCardActivationResponse);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 227:3
 */
FinishCardActivationResponse.Result = $root.lookupEnum('squareup.bizbank.service.FinishCardActivationResponse.Result').values;
/**
 * SOURCE EnqueueSweepRequest @ squareup/bizbank/service.proto at 238:1
 */
export const EnqueueSweepRequest = $root.lookupType('squareup.bizbank.service.EnqueueSweepRequest');
fixType(EnqueueSweepRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(EnqueueSweepRequest);
/**
 * SOURCE EnqueueSweepResponse @ squareup/bizbank/service.proto at 242:1
 */
export const EnqueueSweepResponse = $root.lookupType('squareup.bizbank.service.EnqueueSweepResponse');
fixType(EnqueueSweepResponse);
Builder.createAndAttachToType(EnqueueSweepResponse);
/**
 * SOURCE GetBalanceRequest @ squareup/bizbank/service.proto at 244:1
 */
export const GetBalanceRequest = $root.lookupType('squareup.bizbank.service.GetBalanceRequest');
fixType(GetBalanceRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetBalanceRequest);
/**
 * SOURCE GetBalanceResponse @ squareup/bizbank/service.proto at 248:1
 */
export const GetBalanceResponse = $root.lookupType('squareup.bizbank.service.GetBalanceResponse');
fixType(GetBalanceResponse, {
  balance: { required: true },
  maxInstantDepositAmount: { required: true },
});
Builder.createAndAttachToType(GetBalanceResponse);
/**
 * SOURCE GetBizbankAccountRequest @ squareup/bizbank/service.proto at 254:1
 */
export const GetBizbankAccountRequest = $root.lookupType('squareup.bizbank.service.GetBizbankAccountRequest');
fixType(GetBizbankAccountRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetBizbankAccountRequest);
/**
 * SOURCE GetBizbankAccountResponse @ squareup/bizbank/service.proto at 259:1
 */
export const GetBizbankAccountResponse = $root.lookupType('squareup.bizbank.service.GetBizbankAccountResponse');
fixType(GetBizbankAccountResponse);
Builder.createAndAttachToType(GetBizbankAccountResponse);
/**
 * SOURCE BizbankAccount @ squareup/bizbank/service.proto at 260:3
 */
GetBizbankAccountResponse.BizbankAccount = $root.lookupType('squareup.bizbank.service.GetBizbankAccountResponse.BizbankAccount');
fixType(GetBizbankAccountResponse.BizbankAccount);
Builder.createAndAttachToType(GetBizbankAccountResponse.BizbankAccount);
/**
 * Specific reasons about why a unit cannot order a card.
 *
 * SOURCE UnitIneligibilityReason @ squareup/bizbank/service.proto at 284:1
 */
export const UnitIneligibilityReason = $root.lookupEnum('squareup.bizbank.service.UnitIneligibilityReason').values;
/**
 * SOURCE GetCardOrderingEligibilityRequest @ squareup/bizbank/service.proto at 306:1
 */
export const GetCardOrderingEligibilityRequest = $root.lookupType('squareup.bizbank.service.GetCardOrderingEligibilityRequest');
fixType(GetCardOrderingEligibilityRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetCardOrderingEligibilityRequest);
/**
 * SOURCE GetCardOrderingEligibilityResponse @ squareup/bizbank/service.proto at 311:1
 */
export const GetCardOrderingEligibilityResponse = $root.lookupType('squareup.bizbank.service.GetCardOrderingEligibilityResponse');
fixType(GetCardOrderingEligibilityResponse);
Builder.createAndAttachToType(GetCardOrderingEligibilityResponse);
/**
 * SOURCE GetCardActivityRequest @ squareup/bizbank/service.proto at 321:1
 */
export const GetCardActivityRequest = $root.lookupType('squareup.bizbank.service.GetCardActivityRequest');
fixType(GetCardActivityRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetCardActivityRequest);
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 325:3
 */
GetCardActivityRequest.Filters = $root.lookupType('squareup.bizbank.service.GetCardActivityRequest.Filters');
fixType(GetCardActivityRequest.Filters);
Builder.createAndAttachToType(GetCardActivityRequest.Filters);
/**
 * SOURCE DateSource @ squareup/bizbank/service.proto at 326:5
 */
GetCardActivityRequest.Filters.DateSource = $root.lookupEnum('squareup.bizbank.service.GetCardActivityRequest.Filters.DateSource').values;
/**
 * SOURCE GetCardActivityResponse @ squareup/bizbank/service.proto at 356:1
 */
export const GetCardActivityResponse = $root.lookupType('squareup.bizbank.service.GetCardActivityResponse');
fixType(GetCardActivityResponse, {
  batchResponse: { required: true },
});
Builder.createAndAttachToType(GetCardActivityResponse);
/**
 * SOURCE BatchResponse @ squareup/bizbank/service.proto at 357:3
 */
GetCardActivityResponse.BatchResponse = $root.lookupType('squareup.bizbank.service.GetCardActivityResponse.BatchResponse');
fixType(GetCardActivityResponse.BatchResponse);
Builder.createAndAttachToType(GetCardActivityResponse.BatchResponse);
/**
 * SOURCE GetCardCustomizationRequest @ squareup/bizbank/service.proto at 388:1
 */
export const GetCardCustomizationRequest = $root.lookupType('squareup.bizbank.service.GetCardCustomizationRequest');
fixType(GetCardCustomizationRequest);
Builder.createAndAttachToType(GetCardCustomizationRequest);
/**
 * SOURCE CardCustomization @ squareup/bizbank/service.proto at 397:1
 */
export const CardCustomization = $root.lookupType('squareup.bizbank.service.CardCustomization');
fixType(CardCustomization);
Builder.createAndAttachToType(CardCustomization);
/**
 * SOURCE GetCardCustomizationResponse @ squareup/bizbank/service.proto at 402:1
 */
export const GetCardCustomizationResponse = $root.lookupType('squareup.bizbank.service.GetCardCustomizationResponse');
fixType(GetCardCustomizationResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(GetCardCustomizationResponse);
/**
 * SOURCE GetEnabledRequest @ squareup/bizbank/service.proto at 412:1
 */
export const GetEnabledRequest = $root.lookupType('squareup.bizbank.service.GetEnabledRequest');
fixType(GetEnabledRequest);
Builder.createAndAttachToType(GetEnabledRequest);
/**
 * SOURCE GetEnabledResponse @ squareup/bizbank/service.proto at 417:1
 */
export const GetEnabledResponse = $root.lookupType('squareup.bizbank.service.GetEnabledResponse');
fixType(GetEnabledResponse);
Builder.createAndAttachToType(GetEnabledResponse);
/**
 * SOURCE EnabledAttribute @ squareup/bizbank/service.proto at 421:3
 */
GetEnabledResponse.EnabledAttribute = $root.lookupType('squareup.bizbank.service.GetEnabledResponse.EnabledAttribute');
fixType(GetEnabledResponse.EnabledAttribute, {
  unitToken: { notEmpty: true },
  isEnabled: { required: true },
});
Builder.createAndAttachToType(GetEnabledResponse.EnabledAttribute);
/**
 * SOURCE GetEnabledHistoryRequest @ squareup/bizbank/service.proto at 432:1
 */
export const GetEnabledHistoryRequest = $root.lookupType('squareup.bizbank.service.GetEnabledHistoryRequest');
fixType(GetEnabledHistoryRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetEnabledHistoryRequest);
/**
 * SOURCE GetEnabledHistoryResponse @ squareup/bizbank/service.proto at 436:1
 */
export const GetEnabledHistoryResponse = $root.lookupType('squareup.bizbank.service.GetEnabledHistoryResponse');
fixType(GetEnabledHistoryResponse);
Builder.createAndAttachToType(GetEnabledHistoryResponse);
/**
 * SOURCE DateTimeIntervals @ squareup/bizbank/service.proto at 437:3
 */
GetEnabledHistoryResponse.DateTimeIntervals = $root.lookupType('squareup.bizbank.service.GetEnabledHistoryResponse.DateTimeIntervals');
fixType(GetEnabledHistoryResponse.DateTimeIntervals);
Builder.createAndAttachToType(GetEnabledHistoryResponse.DateTimeIntervals);
/**
 * SOURCE GetCardBillingAddressRequest @ squareup/bizbank/service.proto at 448:1
 */
export const GetCardBillingAddressRequest = $root.lookupType('squareup.bizbank.service.GetCardBillingAddressRequest');
fixType(GetCardBillingAddressRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetCardBillingAddressRequest);
/**
 * SOURCE GetCardBillingAddressResponse @ squareup/bizbank/service.proto at 452:1
 */
export const GetCardBillingAddressResponse = $root.lookupType('squareup.bizbank.service.GetCardBillingAddressResponse');
fixType(GetCardBillingAddressResponse);
Builder.createAndAttachToType(GetCardBillingAddressResponse);
/**
 * SOURCE DigitalWalletToken @ squareup/bizbank/service.proto at 456:1
 */
export const DigitalWalletToken = $root.lookupType('squareup.bizbank.service.DigitalWalletToken');
fixType(DigitalWalletToken);
Builder.createAndAttachToType(DigitalWalletToken);
/**
 * SOURCE GetDigitalWalletTokenRequest @ squareup/bizbank/service.proto at 473:1
 */
export const GetDigitalWalletTokenRequest = $root.lookupType('squareup.bizbank.service.GetDigitalWalletTokenRequest');
fixType(GetDigitalWalletTokenRequest, {
  digitalWalletToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetDigitalWalletTokenRequest);
/**
 * SOURCE GetDigitalWalletTokenResponse @ squareup/bizbank/service.proto at 477:1
 */
export const GetDigitalWalletTokenResponse = $root.lookupType('squareup.bizbank.service.GetDigitalWalletTokenResponse');
fixType(GetDigitalWalletTokenResponse);
Builder.createAndAttachToType(GetDigitalWalletTokenResponse);
/**
 * SOURCE GetDigitalWalletTokensForUnitRequest @ squareup/bizbank/service.proto at 481:1
 */
export const GetDigitalWalletTokensForUnitRequest = $root.lookupType('squareup.bizbank.service.GetDigitalWalletTokensForUnitRequest');
fixType(GetDigitalWalletTokensForUnitRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetDigitalWalletTokensForUnitRequest);
/**
 * SOURCE GetDigitalWalletTokensForUnitResponse @ squareup/bizbank/service.proto at 485:1
 */
export const GetDigitalWalletTokensForUnitResponse = $root.lookupType('squareup.bizbank.service.GetDigitalWalletTokensForUnitResponse');
fixType(GetDigitalWalletTokensForUnitResponse);
Builder.createAndAttachToType(GetDigitalWalletTokensForUnitResponse);
/**
 * SOURCE GetRolledUpActivityRequest @ squareup/bizbank/service.proto at 489:1
 */
export const GetRolledUpActivityRequest = $root.lookupType('squareup.bizbank.service.GetRolledUpActivityRequest');
fixType(GetRolledUpActivityRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetRolledUpActivityRequest);
/**
 * SOURCE SortOrder @ squareup/bizbank/service.proto at 490:3
 */
GetRolledUpActivityRequest.SortOrder = $root.lookupEnum('squareup.bizbank.service.GetRolledUpActivityRequest.SortOrder').values;
/**
 * SOURCE RolledUpActivityType @ squareup/bizbank/service.proto at 494:3
 */
GetRolledUpActivityRequest.RolledUpActivityType = $root.lookupEnum('squareup.bizbank.service.GetRolledUpActivityRequest.RolledUpActivityType').values;
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 501:3
 */
GetRolledUpActivityRequest.Filters = $root.lookupType('squareup.bizbank.service.GetRolledUpActivityRequest.Filters');
fixType(GetRolledUpActivityRequest.Filters);
Builder.createAndAttachToType(GetRolledUpActivityRequest.Filters);
/**
 * SOURCE GetRolledUpActivityResponse @ squareup/bizbank/service.proto at 530:1
 */
export const GetRolledUpActivityResponse = $root.lookupType('squareup.bizbank.service.GetRolledUpActivityResponse');
fixType(GetRolledUpActivityResponse);
Builder.createAndAttachToType(GetRolledUpActivityResponse);
/**
 * SOURCE Fee @ squareup/bizbank/service.proto at 531:3
 */
GetRolledUpActivityResponse.Fee = $root.lookupType('squareup.bizbank.service.GetRolledUpActivityResponse.Fee');
fixType(GetRolledUpActivityResponse.Fee);
Builder.createAndAttachToType(GetRolledUpActivityResponse.Fee);
/**
 * SOURCE FeeType @ squareup/bizbank/service.proto at 532:5
 */
GetRolledUpActivityResponse.Fee.FeeType = $root.lookupEnum('squareup.bizbank.service.GetRolledUpActivityResponse.Fee.FeeType').values;
/**
 * SOURCE RolledUpCardActivity @ squareup/bizbank/service.proto at 540:3
 */
GetRolledUpActivityResponse.RolledUpCardActivity = $root.lookupType('squareup.bizbank.service.GetRolledUpActivityResponse.RolledUpCardActivity');
fixType(GetRolledUpActivityResponse.RolledUpCardActivity);
Builder.createAndAttachToType(GetRolledUpActivityResponse.RolledUpCardActivity);
/**
 * SOURCE GetSpendingLimitsRequest @ squareup/bizbank/service.proto at 551:1
 */
export const GetSpendingLimitsRequest = $root.lookupType('squareup.bizbank.service.GetSpendingLimitsRequest');
fixType(GetSpendingLimitsRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetSpendingLimitsRequest);
/**
 * SOURCE GetSpendingLimitsResponse @ squareup/bizbank/service.proto at 555:1
 */
export const GetSpendingLimitsResponse = $root.lookupType('squareup.bizbank.service.GetSpendingLimitsResponse');
fixType(GetSpendingLimitsResponse);
Builder.createAndAttachToType(GetSpendingLimitsResponse);
/**
 * SOURCE SpendSummary @ squareup/bizbank/service.proto at 556:3
 */
GetSpendingLimitsResponse.SpendSummary = $root.lookupType('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary');
fixType(GetSpendingLimitsResponse.SpendSummary);
Builder.createAndAttachToType(GetSpendingLimitsResponse.SpendSummary);
/**
 * SOURCE SpendType @ squareup/bizbank/service.proto at 557:5
 */
GetSpendingLimitsResponse.SpendSummary.SpendType = $root.lookupEnum('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendType').values;
/**
 * SOURCE SpendLimit @ squareup/bizbank/service.proto at 569:5
 */
GetSpendingLimitsResponse.SpendSummary.SpendLimit = $root.lookupType('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit');
fixType(GetSpendingLimitsResponse.SpendSummary.SpendLimit);
Builder.createAndAttachToType(GetSpendingLimitsResponse.SpendSummary.SpendLimit);
/**
 * SOURCE Cadence @ squareup/bizbank/service.proto at 570:7
 */
GetSpendingLimitsResponse.SpendSummary.SpendLimit.Cadence = $root.lookupEnum('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.Cadence').values;
/**
 * SOURCE CardType @ squareup/bizbank/service.proto at 577:7
 */
GetSpendingLimitsResponse.SpendSummary.SpendLimit.CardType = $root.lookupEnum('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.CardType').values;
/**
 * SOURCE GetAtmLimitsRequest @ squareup/bizbank/service.proto at 608:1
 */
export const GetAtmLimitsRequest = $root.lookupType('squareup.bizbank.service.GetAtmLimitsRequest');
fixType(GetAtmLimitsRequest, {
  cardToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetAtmLimitsRequest);
/**
 * SOURCE GetAtmLimitsResponse @ squareup/bizbank/service.proto at 612:1
 */
export const GetAtmLimitsResponse = $root.lookupType('squareup.bizbank.service.GetAtmLimitsResponse');
fixType(GetAtmLimitsResponse);
Builder.createAndAttachToType(GetAtmLimitsResponse);
/**
 * SOURCE Limit @ squareup/bizbank/service.proto at 613:3
 */
GetAtmLimitsResponse.Limit = $root.lookupType('squareup.bizbank.service.GetAtmLimitsResponse.Limit');
fixType(GetAtmLimitsResponse.Limit);
Builder.createAndAttachToType(GetAtmLimitsResponse.Limit);
/**
 * SOURCE Cadence @ squareup/bizbank/service.proto at 614:5
 */
GetAtmLimitsResponse.Limit.Cadence = $root.lookupEnum('squareup.bizbank.service.GetAtmLimitsResponse.Limit.Cadence').values;
/**
 * --
 * @desc A request to create an email invitation to secondary card holder. They can
 * order square debit card by following the email.
 * --
 *
 * SOURCE CreateCardInvitationRequest @ squareup/bizbank/service.proto at 631:1
 */
export const CreateCardInvitationRequest = $root.lookupType('squareup.bizbank.service.CreateCardInvitationRequest');
fixType(CreateCardInvitationRequest, {
  firstName: { notEmpty: true },
  lastName: { notEmpty: true },
  email: { notEmpty: true },
  balanceId: { notEmpty: true },
  idempotenceKey: { notEmpty: true },
});
Builder.createAndAttachToType(CreateCardInvitationRequest);
/**
 * --
 * @desc A response that includes the open invitation.
 * --
 *
 * SOURCE CreateCardInvitationResponse @ squareup/bizbank/service.proto at 665:1
 */
export const CreateCardInvitationResponse = $root.lookupType('squareup.bizbank.service.CreateCardInvitationResponse');
fixType(CreateCardInvitationResponse);
Builder.createAndAttachToType(CreateCardInvitationResponse);
/**
 * SOURCE SendNotificationRequest @ squareup/bizbank/service.proto at 669:1
 */
export const SendNotificationRequest = $root.lookupType('squareup.bizbank.service.SendNotificationRequest');
fixType(SendNotificationRequest, {
  idempotencyKey: { notEmpty: true },
});
Builder.createAndAttachToType(SendNotificationRequest);
/**
 * SOURCE CardInvitationEmailPayload @ squareup/bizbank/service.proto at 670:3
 */
SendNotificationRequest.CardInvitationEmailPayload = $root.lookupType('squareup.bizbank.service.SendNotificationRequest.CardInvitationEmailPayload');
fixType(SendNotificationRequest.CardInvitationEmailPayload, {
  cardInvitationToken: { notEmpty: true },
});
Builder.createAndAttachToType(SendNotificationRequest.CardInvitationEmailPayload);
/**
 * SOURCE SendNotificationResponse @ squareup/bizbank/service.proto at 680:1
 */
export const SendNotificationResponse = $root.lookupType('squareup.bizbank.service.SendNotificationResponse');
fixType(SendNotificationResponse);
Builder.createAndAttachToType(SendNotificationResponse);
/**
 * --
 * @desc Represents card ownership.
 * --
 *
 * SOURCE CardAssignment @ squareup/bizbank/service.proto at 687:1
 */
export const CardAssignment = $root.lookupType('squareup.bizbank.service.CardAssignment');
fixType(CardAssignment);
Builder.createAndAttachToType(CardAssignment);
/**
 * --
 * @desc A request to find card holders by card tokens.
 * --
 *
 * SOURCE SearchCardAssignmentsRequest @ squareup/bizbank/service.proto at 696:1
 */
export const SearchCardAssignmentsRequest = $root.lookupType('squareup.bizbank.service.SearchCardAssignmentsRequest');
fixType(SearchCardAssignmentsRequest);
Builder.createAndAttachToType(SearchCardAssignmentsRequest);
/**
 * SOURCE CardAssignmentsFilter @ squareup/bizbank/service.proto at 697:3
 */
SearchCardAssignmentsRequest.CardAssignmentsFilter = $root.lookupType('squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsFilter');
fixType(SearchCardAssignmentsRequest.CardAssignmentsFilter);
Builder.createAndAttachToType(SearchCardAssignmentsRequest.CardAssignmentsFilter);
/**
 * SOURCE CardAssignmentsQuery @ squareup/bizbank/service.proto at 700:3
 */
SearchCardAssignmentsRequest.CardAssignmentsQuery = $root.lookupType('squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsQuery');
fixType(SearchCardAssignmentsRequest.CardAssignmentsQuery);
Builder.createAndAttachToType(SearchCardAssignmentsRequest.CardAssignmentsQuery);
/**
 * SOURCE SearchCardAssignmentsResponse @ squareup/bizbank/service.proto at 706:1
 */
export const SearchCardAssignmentsResponse = $root.lookupType('squareup.bizbank.service.SearchCardAssignmentsResponse');
fixType(SearchCardAssignmentsResponse);
Builder.createAndAttachToType(SearchCardAssignmentsResponse);
/**
 * SOURCE ListCardsRequest @ squareup/bizbank/service.proto at 710:1
 */
export const ListCardsRequest = $root.lookupType('squareup.bizbank.service.ListCardsRequest');
fixType(ListCardsRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(ListCardsRequest);
/**
 * SOURCE SortOrder @ squareup/bizbank/service.proto at 711:3
 */
ListCardsRequest.SortOrder = $root.lookupEnum('squareup.bizbank.service.ListCardsRequest.SortOrder').values;
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 718:3
 */
ListCardsRequest.Filters = $root.lookupType('squareup.bizbank.service.ListCardsRequest.Filters');
fixType(ListCardsRequest.Filters);
Builder.createAndAttachToType(ListCardsRequest.Filters);
/**
 * SOURCE ListCardsResponse @ squareup/bizbank/service.proto at 730:1
 */
export const ListCardsResponse = $root.lookupType('squareup.bizbank.service.ListCardsResponse');
fixType(ListCardsResponse);
Builder.createAndAttachToType(ListCardsResponse);
/**
 * SOURCE CardBrand @ squareup/bizbank/service.proto at 735:1
 */
export const CardBrand = $root.lookupEnum('squareup.bizbank.service.CardBrand').values;
/**
 * SOURCE CardData @ squareup/bizbank/service.proto at 740:1
 */
export const CardData = $root.lookupType('squareup.bizbank.service.CardData');
fixType(CardData, {
  cardState: { required: true },
  cardBrand: { required: true },
  cardType: { required: true },
});
Builder.createAndAttachToType(CardData);
/**
 * SOURCE CardState @ squareup/bizbank/service.proto at 772:3
 */
CardData.CardState = $root.lookupEnum('squareup.bizbank.service.CardData.CardState').values;
/**
 * SOURCE CardType @ squareup/bizbank/service.proto at 792:3
 */
CardData.CardType = $root.lookupEnum('squareup.bizbank.service.CardData.CardType').values;
/**
 * SOURCE CardActivity @ squareup/bizbank/service.proto at 818:1
 */
export const CardActivity = $root.lookupType('squareup.bizbank.service.CardActivity');
fixType(CardActivity, {
  transactionToken: { required: true },
  amount: { required: true },
  description: { required: true },
  activityType: { required: true },
  transactionState: { required: true },
  occurredAt: { required: true },
});
Builder.createAndAttachToType(CardActivity);
/**
 * SOURCE ActivityType @ squareup/bizbank/service.proto at 819:3
 */
CardActivity.ActivityType = $root.lookupEnum('squareup.bizbank.service.CardActivity.ActivityType').values;
/**
 * SOURCE DepositCardInfo @ squareup/bizbank/service.proto at 840:3
 */
CardActivity.DepositCardInfo = $root.lookupType('squareup.bizbank.service.CardActivity.DepositCardInfo');
fixType(CardActivity.DepositCardInfo);
Builder.createAndAttachToType(CardActivity.DepositCardInfo);
/**
 * SOURCE DepositBankInfo @ squareup/bizbank/service.proto at 847:3
 */
CardActivity.DepositBankInfo = $root.lookupType('squareup.bizbank.service.CardActivity.DepositBankInfo');
fixType(CardActivity.DepositBankInfo);
Builder.createAndAttachToType(CardActivity.DepositBankInfo);
/**
 * SOURCE ProvideFeedbackRequest @ squareup/bizbank/service.proto at 871:1
 */
export const ProvideFeedbackRequest = $root.lookupType('squareup.bizbank.service.ProvideFeedbackRequest');
fixType(ProvideFeedbackRequest, {
  idempotenceKey: { notEmpty: true },
  unitToken: { notEmpty: true },
  feedbackText: { notEmpty: true },
  feedbackSource: { required: true },
});
Builder.createAndAttachToType(ProvideFeedbackRequest);
/**
 * SOURCE FeedbackSource @ squareup/bizbank/service.proto at 877:3
 */
ProvideFeedbackRequest.FeedbackSource = $root.lookupEnum('squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource').values;
/**
 * Maps to squareup.banklin.service.ProvisionDigitalWalletTokenRequest
 *
 * SOURCE ProvisionDigitalWalletTokenRequest @ squareup/bizbank/service.proto at 901:1
 */
export const ProvisionDigitalWalletTokenRequest = $root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest');
fixType(ProvisionDigitalWalletTokenRequest);
Builder.createAndAttachToType(ProvisionDigitalWalletTokenRequest);
/**
 * Maps to squareup.banklin.service.DeviceType
 *
 * SOURCE DeviceType @ squareup/bizbank/service.proto at 918:3
 */
ProvisionDigitalWalletTokenRequest.DeviceType = $root.lookupEnum('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.DeviceType').values;
/**
 * SOURCE ApplePayRequest @ squareup/bizbank/service.proto at 924:3
 */
ProvisionDigitalWalletTokenRequest.ApplePayRequest = $root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.ApplePayRequest');
fixType(ProvisionDigitalWalletTokenRequest.ApplePayRequest);
Builder.createAndAttachToType(ProvisionDigitalWalletTokenRequest.ApplePayRequest);
/**
 * SOURCE GooglePayRequest @ squareup/bizbank/service.proto at 939:3
 */
ProvisionDigitalWalletTokenRequest.GooglePayRequest = $root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.GooglePayRequest');
fixType(ProvisionDigitalWalletTokenRequest.GooglePayRequest);
Builder.createAndAttachToType(ProvisionDigitalWalletTokenRequest.GooglePayRequest);
/**
 * SOURCE ProvisionDigitalWalletTokenResponse @ squareup/bizbank/service.proto at 951:1
 */
export const ProvisionDigitalWalletTokenResponse = $root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenResponse');
fixType(ProvisionDigitalWalletTokenResponse);
Builder.createAndAttachToType(ProvisionDigitalWalletTokenResponse);
/**
 * SOURCE ApplePayResponse @ squareup/bizbank/service.proto at 959:3
 */
ProvisionDigitalWalletTokenResponse.ApplePayResponse = $root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.ApplePayResponse');
fixType(ProvisionDigitalWalletTokenResponse.ApplePayResponse);
Builder.createAndAttachToType(ProvisionDigitalWalletTokenResponse.ApplePayResponse);
/**
 * SOURCE GooglePayResponse @ squareup/bizbank/service.proto at 974:3
 */
ProvisionDigitalWalletTokenResponse.GooglePayResponse = $root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.GooglePayResponse');
fixType(ProvisionDigitalWalletTokenResponse.GooglePayResponse);
Builder.createAndAttachToType(ProvisionDigitalWalletTokenResponse.GooglePayResponse);
/**
 * SOURCE ProvideFeedbackResponse @ squareup/bizbank/service.proto at 982:1
 */
export const ProvideFeedbackResponse = $root.lookupType('squareup.bizbank.service.ProvideFeedbackResponse');
fixType(ProvideFeedbackResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(ProvideFeedbackResponse);
/**
 * SOURCE SetCardBillingAddressRequest @ squareup/bizbank/service.proto at 986:1
 */
export const SetCardBillingAddressRequest = $root.lookupType('squareup.bizbank.service.SetCardBillingAddressRequest');
fixType(SetCardBillingAddressRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(SetCardBillingAddressRequest);
/**
 * SOURCE SetCardBillingAddressResponse @ squareup/bizbank/service.proto at 991:1
 */
export const SetCardBillingAddressResponse = $root.lookupType('squareup.bizbank.service.SetCardBillingAddressResponse');
fixType(SetCardBillingAddressResponse);
Builder.createAndAttachToType(SetCardBillingAddressResponse);
/**
 * SOURCE FailureReason @ squareup/bizbank/service.proto at 996:3
 */
SetCardBillingAddressResponse.FailureReason = $root.lookupEnum('squareup.bizbank.service.SetCardBillingAddressResponse.FailureReason').values;
/**
 * SOURCE SetEnabledRequest @ squareup/bizbank/service.proto at 1005:1
 */
export const SetEnabledRequest = $root.lookupType('squareup.bizbank.service.SetEnabledRequest');
fixType(SetEnabledRequest, {
  unitToken: { notEmpty: true },
  enabled: { required: true },
});
Builder.createAndAttachToType(SetEnabledRequest);
/**
 * SOURCE SetEnabledResponse @ squareup/bizbank/service.proto at 1010:1
 */
export const SetEnabledResponse = $root.lookupType('squareup.bizbank.service.SetEnabledResponse');
fixType(SetEnabledResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(SetEnabledResponse);
/**
 * SOURCE SetPasscodeRequest @ squareup/bizbank/service.proto at 1014:1
 */
export const SetPasscodeRequest = $root.lookupType('squareup.bizbank.service.SetPasscodeRequest');
fixType(SetPasscodeRequest, {
  passcode: { notEmpty: true },
  cardToken: { notEmpty: true },
});
Builder.createAndAttachToType(SetPasscodeRequest);
/**
 * SOURCE SetPasscodeResponse @ squareup/bizbank/service.proto at 1023:1
 */
export const SetPasscodeResponse = $root.lookupType('squareup.bizbank.service.SetPasscodeResponse');
fixType(SetPasscodeResponse, {
  result: { required: true },
});
Builder.createAndAttachToType(SetPasscodeResponse);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1026:3
 */
SetPasscodeResponse.Result = $root.lookupEnum('squareup.bizbank.service.SetPasscodeResponse.Result').values;
/**
 * SOURCE StartCardActivationRequest @ squareup/bizbank/service.proto at 1036:1
 */
export const StartCardActivationRequest = $root.lookupType('squareup.bizbank.service.StartCardActivationRequest');
fixType(StartCardActivationRequest, {
  unitToken: { notEmpty: true },
  cardToken: { notEmpty: true },
});
Builder.createAndAttachToType(StartCardActivationRequest);
/**
 * SOURCE StartCardActivationResponse @ squareup/bizbank/service.proto at 1045:1
 */
export const StartCardActivationResponse = $root.lookupType('squareup.bizbank.service.StartCardActivationResponse');
fixType(StartCardActivationResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(StartCardActivationResponse);
/**
 * SOURCE StartIdentityVerificationRequest @ squareup/bizbank/service.proto at 1050:1
 */
export const StartIdentityVerificationRequest = $root.lookupType('squareup.bizbank.service.StartIdentityVerificationRequest');
fixType(StartIdentityVerificationRequest, {
  unitToken: { required: true },
});
Builder.createAndAttachToType(StartIdentityVerificationRequest);
/**
 * SOURCE StartIdentityVerificationResponse @ squareup/bizbank/service.proto at 1057:1
 */
export const StartIdentityVerificationResponse = $root.lookupType('squareup.bizbank.service.StartIdentityVerificationResponse');
fixType(StartIdentityVerificationResponse);
Builder.createAndAttachToType(StartIdentityVerificationResponse);
/**
 * SOURCE StartIssueCardRequest @ squareup/bizbank/service.proto at 1061:1
 */
export const StartIssueCardRequest = $root.lookupType('squareup.bizbank.service.StartIssueCardRequest');
fixType(StartIssueCardRequest, {
  unitToken: { notEmpty: true },
  shippingAddress: { required: true },
});
Builder.createAndAttachToType(StartIssueCardRequest);
/**
 * SOURCE StartIssueCardResponse @ squareup/bizbank/service.proto at 1066:1
 */
export const StartIssueCardResponse = $root.lookupType('squareup.bizbank.service.StartIssueCardResponse');
fixType(StartIssueCardResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(StartIssueCardResponse);
/**
 * SOURCE AddressNormalizationResult @ squareup/bizbank/service.proto at 1076:3
 */
StartIssueCardResponse.AddressNormalizationResult = $root.lookupEnum('squareup.bizbank.service.StartIssueCardResponse.AddressNormalizationResult').values;
/**
 * SOURCE TwoFactorAuthenticationRequestType @ squareup/bizbank/service.proto at 1084:1
 */
export const TwoFactorAuthenticationRequestType = $root.lookupEnum('squareup.bizbank.service.TwoFactorAuthenticationRequestType').values;
/**
 * SOURCE StartTwoFactorAuthenticationRequest @ squareup/bizbank/service.proto at 1092:1
 */
export const StartTwoFactorAuthenticationRequest = $root.lookupType('squareup.bizbank.service.StartTwoFactorAuthenticationRequest');
fixType(StartTwoFactorAuthenticationRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(StartTwoFactorAuthenticationRequest);
/**
 * SOURCE StartTwoFactorAuthenticationResponse @ squareup/bizbank/service.proto at 1101:1
 */
export const StartTwoFactorAuthenticationResponse = $root.lookupType('squareup.bizbank.service.StartTwoFactorAuthenticationResponse');
fixType(StartTwoFactorAuthenticationResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(StartTwoFactorAuthenticationResponse);
/**
 * SOURCE ToggleCardRequest @ squareup/bizbank/service.proto at 1105:1
 */
export const ToggleCardRequest = $root.lookupType('squareup.bizbank.service.ToggleCardRequest');
fixType(ToggleCardRequest, {
  unitToken: { notEmpty: true },
  cardToken: { notEmpty: true },
});
Builder.createAndAttachToType(ToggleCardRequest);
/**
 * SOURCE ToggleCardResponse @ squareup/bizbank/service.proto at 1112:1
 */
export const ToggleCardResponse = $root.lookupType('squareup.bizbank.service.ToggleCardResponse');
fixType(ToggleCardResponse);
Builder.createAndAttachToType(ToggleCardResponse);
/**
 * SOURCE VerifyCardActivationTokenRequest @ squareup/bizbank/service.proto at 1118:1
 */
export const VerifyCardActivationTokenRequest = $root.lookupType('squareup.bizbank.service.VerifyCardActivationTokenRequest');
fixType(VerifyCardActivationTokenRequest, {
  activationToken: { notEmpty: true },
});
Builder.createAndAttachToType(VerifyCardActivationTokenRequest);
/**
 * SOURCE VerifyCardActivationTokenResponse @ squareup/bizbank/service.proto at 1125:1
 */
export const VerifyCardActivationTokenResponse = $root.lookupType('squareup.bizbank.service.VerifyCardActivationTokenResponse');
fixType(VerifyCardActivationTokenResponse, {
  result: { required: true },
});
Builder.createAndAttachToType(VerifyCardActivationTokenResponse);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1131:3
 */
VerifyCardActivationTokenResponse.Result = $root.lookupEnum('squareup.bizbank.service.VerifyCardActivationTokenResponse.Result').values;
/**
 * SOURCE VerifyTwoFactorAuthenticationTokenRequest @ squareup/bizbank/service.proto at 1140:1
 */
export const VerifyTwoFactorAuthenticationTokenRequest = $root.lookupType('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest');
fixType(VerifyTwoFactorAuthenticationTokenRequest, {
  authenticationToken: { notEmpty: true },
  requestType: { required: true },
});
Builder.createAndAttachToType(VerifyTwoFactorAuthenticationTokenRequest);
/**
 * SOURCE VerifyTwoFactorAuthenticationTokenResponse @ squareup/bizbank/service.proto at 1146:1
 */
export const VerifyTwoFactorAuthenticationTokenResponse = $root.lookupType('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse');
fixType(VerifyTwoFactorAuthenticationTokenResponse, {
  result: { required: true },
});
Builder.createAndAttachToType(VerifyTwoFactorAuthenticationTokenResponse);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1152:3
 */
VerifyTwoFactorAuthenticationTokenResponse.Result = $root.lookupEnum('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse.Result').values;
/**
 * SOURCE VoidAuthorizationRequest @ squareup/bizbank/service.proto at 1159:1
 */
export const VoidAuthorizationRequest = $root.lookupType('squareup.bizbank.service.VoidAuthorizationRequest');
fixType(VoidAuthorizationRequest, {
  transactionToken: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(VoidAuthorizationRequest);
/**
 * SOURCE VoidAuthorizationResponse @ squareup/bizbank/service.proto at 1163:1
 */
export const VoidAuthorizationResponse = $root.lookupType('squareup.bizbank.service.VoidAuthorizationResponse');
fixType(VoidAuthorizationResponse);
Builder.createAndAttachToType(VoidAuthorizationResponse);
/**
 * SOURCE IdvState @ squareup/bizbank/service.proto at 1167:1
 */
export const IdvState = $root.lookupEnum('squareup.bizbank.service.IdvState').values;
/**
 * SOURCE GetFundsHoldingAccountRequest @ squareup/bizbank/service.proto at 1202:1
 */
export const GetFundsHoldingAccountRequest = $root.lookupType('squareup.bizbank.service.GetFundsHoldingAccountRequest');
fixType(GetFundsHoldingAccountRequest);
Builder.createAndAttachToType(GetFundsHoldingAccountRequest);
/**
 * SOURCE GetFundsHoldingAccountResponse @ squareup/bizbank/service.proto at 1213:1
 */
export const GetFundsHoldingAccountResponse = $root.lookupType('squareup.bizbank.service.GetFundsHoldingAccountResponse');
fixType(GetFundsHoldingAccountResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(GetFundsHoldingAccountResponse);
/**
 * SOURCE GetIsUserAuthorizedRequest @ squareup/bizbank/service.proto at 1225:1
 */
export const GetIsUserAuthorizedRequest = $root.lookupType('squareup.bizbank.service.GetIsUserAuthorizedRequest');
fixType(GetIsUserAuthorizedRequest, {
  unitToken: { notEmpty: true },
  loggableSessionToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetIsUserAuthorizedRequest);
/**
 * SOURCE GetIsUserAuthorizedResponse @ squareup/bizbank/service.proto at 1232:1
 */
export const GetIsUserAuthorizedResponse = $root.lookupType('squareup.bizbank.service.GetIsUserAuthorizedResponse');
fixType(GetIsUserAuthorizedResponse, {
  isAuthorized: { required: true },
});
Builder.createAndAttachToType(GetIsUserAuthorizedResponse);
/**
 * SOURCE GetPromotionalRewardDescriptionRequest @ squareup/bizbank/service.proto at 1237:1
 */
export const GetPromotionalRewardDescriptionRequest = $root.lookupType('squareup.bizbank.service.GetPromotionalRewardDescriptionRequest');
fixType(GetPromotionalRewardDescriptionRequest, {
  transactionToken: { required: true },
});
Builder.createAndAttachToType(GetPromotionalRewardDescriptionRequest);
/**
 * SOURCE GetPromotionalRewardDescriptionResponse @ squareup/bizbank/service.proto at 1242:1
 */
export const GetPromotionalRewardDescriptionResponse = $root.lookupType('squareup.bizbank.service.GetPromotionalRewardDescriptionResponse');
fixType(GetPromotionalRewardDescriptionResponse);
Builder.createAndAttachToType(GetPromotionalRewardDescriptionResponse);
/**
 * SOURCE Error @ squareup/bizbank/service.proto at 1243:3
 */
GetPromotionalRewardDescriptionResponse.Error = $root.lookupEnum('squareup.bizbank.service.GetPromotionalRewardDescriptionResponse.Error').values;
/**
 * SOURCE LookupUnitRequest @ squareup/bizbank/service.proto at 1271:1
 */
export const LookupUnitRequest = $root.lookupType('squareup.bizbank.service.LookupUnitRequest');
fixType(LookupUnitRequest);
Builder.createAndAttachToType(LookupUnitRequest);
/**
 * SOURCE LookupUnitResponse @ squareup/bizbank/service.proto at 1275:1
 */
export const LookupUnitResponse = $root.lookupType('squareup.bizbank.service.LookupUnitResponse');
fixType(LookupUnitResponse, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(LookupUnitResponse);
/**
 * SOURCE ListDisputedTransactionTokensRequest @ squareup/bizbank/service.proto at 1280:1
 */
export const ListDisputedTransactionTokensRequest = $root.lookupType('squareup.bizbank.service.ListDisputedTransactionTokensRequest');
fixType(ListDisputedTransactionTokensRequest);
Builder.createAndAttachToType(ListDisputedTransactionTokensRequest);
/**
 * SOURCE ListDisputedTransactionTokensResponse @ squareup/bizbank/service.proto at 1284:1
 */
export const ListDisputedTransactionTokensResponse = $root.lookupType('squareup.bizbank.service.ListDisputedTransactionTokensResponse');
fixType(ListDisputedTransactionTokensResponse);
Builder.createAndAttachToType(ListDisputedTransactionTokensResponse);
/**
 * SOURCE ValidateAddressRequest @ squareup/bizbank/service.proto at 1288:1
 */
export const ValidateAddressRequest = $root.lookupType('squareup.bizbank.service.ValidateAddressRequest');
fixType(ValidateAddressRequest, {
  address: { required: true },
});
Builder.createAndAttachToType(ValidateAddressRequest);
/**
 * SOURCE ValidateAddressResponse @ squareup/bizbank/service.proto at 1292:1
 */
export const ValidateAddressResponse = $root.lookupType('squareup.bizbank.service.ValidateAddressResponse');
fixType(ValidateAddressResponse);
Builder.createAndAttachToType(ValidateAddressResponse);
/**
 * SOURCE CorrectedField @ squareup/bizbank/service.proto at 1293:3
 */
ValidateAddressResponse.CorrectedField = $root.lookupEnum('squareup.bizbank.service.ValidateAddressResponse.CorrectedField').values;
/**
 * SOURCE AddressNormalizationResult @ squareup/bizbank/service.proto at 1302:3
 */
ValidateAddressResponse.AddressNormalizationResult = $root.lookupEnum('squareup.bizbank.service.ValidateAddressResponse.AddressNormalizationResult').values;
/**
 * SOURCE UpdateCustomerDataRequest @ squareup/bizbank/service.proto at 1841:1
 */
export const UpdateCustomerDataRequest = $root.lookupType('squareup.bizbank.service.UpdateCustomerDataRequest');
fixType(UpdateCustomerDataRequest);
Builder.createAndAttachToType(UpdateCustomerDataRequest);
/**
 * SOURCE UpdateCustomerDataResponse @ squareup/bizbank/service.proto at 1848:1
 */
export const UpdateCustomerDataResponse = $root.lookupType('squareup.bizbank.service.UpdateCustomerDataResponse');
fixType(UpdateCustomerDataResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(UpdateCustomerDataResponse);
/**
 * SOURCE GetCustomizationSettingsRequest @ squareup/bizbank/service.proto at 2043:1
 */
export const GetCustomizationSettingsRequest = $root.lookupType('squareup.bizbank.service.GetCustomizationSettingsRequest');
fixType(GetCustomizationSettingsRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetCustomizationSettingsRequest);
/**
 * SOURCE GetCustomizationSettingsResponse @ squareup/bizbank/service.proto at 2049:1
 */
export const GetCustomizationSettingsResponse = $root.lookupType('squareup.bizbank.service.GetCustomizationSettingsResponse');
fixType(GetCustomizationSettingsResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(GetCustomizationSettingsResponse);
/**
 * SOURCE IneligibilityReason @ squareup/bizbank/service.proto at 2074:3
 */
GetCustomizationSettingsResponse.IneligibilityReason = $root.lookupEnum('squareup.bizbank.service.GetCustomizationSettingsResponse.IneligibilityReason').values;
/**
 * SOURCE ExistingCustomization @ squareup/bizbank/service.proto at 2083:3
 */
GetCustomizationSettingsResponse.ExistingCustomization = $root.lookupType('squareup.bizbank.service.GetCustomizationSettingsResponse.ExistingCustomization');
fixType(GetCustomizationSettingsResponse.ExistingCustomization);
Builder.createAndAttachToType(GetCustomizationSettingsResponse.ExistingCustomization);
/**
 * SOURCE GetAllStampsRequest @ squareup/bizbank/service.proto at 2090:1
 */
export const GetAllStampsRequest = $root.lookupType('squareup.bizbank.service.GetAllStampsRequest');
fixType(GetAllStampsRequest);
Builder.createAndAttachToType(GetAllStampsRequest);
/**
 * This is a similar object from Franklin since we will be using their drawing tool
 *
 * SOURCE GetAllStampsResponse @ squareup/bizbank/service.proto at 2093:1
 */
export const GetAllStampsResponse = $root.lookupType('squareup.bizbank.service.GetAllStampsResponse');
fixType(GetAllStampsResponse);
Builder.createAndAttachToType(GetAllStampsResponse);
/**
 * SOURCE Stamp @ squareup/bizbank/service.proto at 2097:1
 */
export const Stamp = $root.lookupType('squareup.bizbank.service.Stamp');
fixType(Stamp);
Builder.createAndAttachToType(Stamp);
/**
 * SOURCE GetFontsRequest @ squareup/bizbank/service.proto at 2109:1
 */
export const GetFontsRequest = $root.lookupType('squareup.bizbank.service.GetFontsRequest');
fixType(GetFontsRequest);
Builder.createAndAttachToType(GetFontsRequest);
/**
 * SOURCE GetFontsResponse @ squareup/bizbank/service.proto at 2111:1
 */
export const GetFontsResponse = $root.lookupType('squareup.bizbank.service.GetFontsResponse');
fixType(GetFontsResponse);
Builder.createAndAttachToType(GetFontsResponse);
/**
 * SOURCE Font @ squareup/bizbank/service.proto at 2114:3
 */
GetFontsResponse.Font = $root.lookupType('squareup.bizbank.service.GetFontsResponse.Font');
fixType(GetFontsResponse.Font, {
  fontFamily: { notEmpty: true },
  fontUrl: { notEmpty: true },
});
Builder.createAndAttachToType(GetFontsResponse.Font);
/**
 * SOURCE DeactivateAccountRequest @ squareup/bizbank/service.proto at 2136:1
 */
export const DeactivateAccountRequest = $root.lookupType('squareup.bizbank.service.DeactivateAccountRequest');
fixType(DeactivateAccountRequest, {
  unitToken: { required: true },
  deactivationReason: { required: true },
  source: { required: true },
});
Builder.createAndAttachToType(DeactivateAccountRequest);
/**
 * SOURCE DeactivateAccountResponse @ squareup/bizbank/service.proto at 2148:1
 */
export const DeactivateAccountResponse = $root.lookupType('squareup.bizbank.service.DeactivateAccountResponse');
fixType(DeactivateAccountResponse);
Builder.createAndAttachToType(DeactivateAccountResponse);
/**
 * Hack Week 2024 q2
 *
 * SOURCE MerchantBlockState @ squareup/bizbank/service.proto at 2288:1
 */
export const MerchantBlockState = $root.lookupEnum('squareup.bizbank.service.MerchantBlockState').values;
/**
 * Update the block state given a unit token/merchantein merchant
 *
 * SOURCE UpdateMerchantBlockRequest @ squareup/bizbank/service.proto at 2295:1
 */
export const UpdateMerchantBlockRequest = $root.lookupType('squareup.bizbank.service.UpdateMerchantBlockRequest');
fixType(UpdateMerchantBlockRequest, {
  merchanteinMerchantToken: { notEmpty: true },
  unitToken: { notEmpty: true },
  merchantBlockState: { required: true },
});
Builder.createAndAttachToType(UpdateMerchantBlockRequest);
/**
 * SOURCE UpdateMerchantBlockResponse @ squareup/bizbank/service.proto at 2302:1
 */
export const UpdateMerchantBlockResponse = $root.lookupType('squareup.bizbank.service.UpdateMerchantBlockResponse');
fixType(UpdateMerchantBlockResponse, {
  merchantBlockState: { required: true },
});
Builder.createAndAttachToType(UpdateMerchantBlockResponse);
/**
 * Get the current block state for a unit token/merchantein merchant
 *
 * SOURCE GetMerchantBlockRequest @ squareup/bizbank/service.proto at 2307:1
 */
export const GetMerchantBlockRequest = $root.lookupType('squareup.bizbank.service.GetMerchantBlockRequest');
fixType(GetMerchantBlockRequest, {
  merchanteinMerchantToken: { notEmpty: true },
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetMerchantBlockRequest);
/**
 * SOURCE GetMerchantBlockResponse @ squareup/bizbank/service.proto at 2313:1
 */
export const GetMerchantBlockResponse = $root.lookupType('squareup.bizbank.service.GetMerchantBlockResponse');
fixType(GetMerchantBlockResponse, {
  merchantBlockState: { required: true },
});
Builder.createAndAttachToType(GetMerchantBlockResponse);
/**
 * List all the blocked merchantein merchants for a given unit token
 *
 * SOURCE ListMerchantBlocksRequest @ squareup/bizbank/service.proto at 2318:1
 */
export const ListMerchantBlocksRequest = $root.lookupType('squareup.bizbank.service.ListMerchantBlocksRequest');
fixType(ListMerchantBlocksRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(ListMerchantBlocksRequest);
/**
 * SOURCE ListMerchantBlocksResponse @ squareup/bizbank/service.proto at 2322:1
 */
export const ListMerchantBlocksResponse = $root.lookupType('squareup.bizbank.service.ListMerchantBlocksResponse');
fixType(ListMerchantBlocksResponse);
Builder.createAndAttachToType(ListMerchantBlocksResponse);
/**
 * SOURCE MerchanteinMerchant @ squareup/bizbank/service.proto at 2325:3
 */
ListMerchantBlocksResponse.MerchanteinMerchant = $root.lookupType('squareup.bizbank.service.ListMerchantBlocksResponse.MerchanteinMerchant');
fixType(ListMerchantBlocksResponse.MerchanteinMerchant, {
  token: { notEmpty: true },
  name: { notEmpty: true },
  merchantImage: { required: true },
});
Builder.createAndAttachToType(ListMerchantBlocksResponse.MerchanteinMerchant);
/**
 * SOURCE BizbankService @ squareup/bizbank/service.proto at 1315:1
 */
export const BizbankService = $root.lookupService('squareup.bizbank.service.BizbankService');
